import {
    Component, OnInit, AfterViewInit, ViewChild, ViewChildren, NgModule, Sanitizer,
    SimpleChanges, OnChanges, SecurityContext,
    Directive, ElementRef, HostListener, HostBinding, Input, Output, ViewEncapsulation, AfterViewChecked
} from '@angular/core';

//BuildVersion
import { LowerCasePipe } from '@angular/common';
import { ExamPlayerService } from '../_services/ExamPlayerService'
import { IUserResponseObject } from '../_models/UserResponseObject';
import { QuestionInfo } from '../_models/Question'; 
import * as $ from 'jquery';
import * as myGlobals from "../../globals";
import { BrowserModule, DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { Jsonp } from '@angular/http';
declare var HotSpotH5: any;
declare var FunctionCall: any, InitializeObjects: any, mCustomScrollbar: any;
declare var mnClient: any, mnLeftLogo: any, mnRightLogo: any, RB_UIMgnt: any,
    putOnWait: any, HotSpotHtml5: any, RB_UIMgnt: any, Theme: any, Test: any, Summary: any, Message: any, Navigation: any,
    TestFunctions: any, StandardTimeFunctions: any, ActionSequence: any, Question: any, ActionStatusType: any, ctTimer: any, 
    ResponseProcessing: any, Response: any, _timerID: any, TimerAt: any, CKEDITOR: any, CloseTest: any, DynamicWindow: any, CKEDITOR: any, StateFailed: any, userCutlure: any, _buildVersion: any, applicationPath: any, isSingleQuestionPreview: any, FeedbackCultureVal: any, 
    OptionAreaCultVal: any,ReturnToURL: any,hlrUpdateTimeAvail: any,IsNextQuesTimer: Boolean,ShowSectionInstructionDynamically: any,ShowEndsecInst:any,RvwTime:any;

export enum KEY_CODE {
    ALT_D = 68,
    ALT_E = 69,
    ALT_H = 72,
    ALT_L = 76,
    ALT_N = 78,
    ALT_Y = 89,
    ALT_K = 75,
    ALT_R = 82,
    ALT_S = 83,
    ALT_U = 85,
	ALT_W = 87,
    ALT_A = 65,
	ALT_O = 79,
	ALT_P = 80

}
@Component({
    templateUrl: 'app.ItemViews.html'
})
export class TaketestComponent implements OnInit {
    private static instance: TaketestComponent;
    @HostListener('window:beforeunload', ['$event'])
    SaveReponse($event) {
        if (this.isEndExam && this.TestInfo.Status == 1) {
            if (this.EndExamMessages == 1 || this.EndExamMessages == 2) {
                this.assessmentService.GetTestResultSummary(true).subscribe(result => {
                    this.resultSummary = result;
                });
            }
        }
        if (Test.TestInfo.TestPrefController != null && Test.TestInfo.TestPrefController.RequestType == "525" && this.TestInfo.Status != 2 && !this.isEndExam)
            this.CallEvaluateInWindowClose(true);
        else if (this.TestInfo.Status == 2)
            this.CloseTest();
    }
    model: any = {};
    loading = false;
    public loggedIn: boolean;
    msg;
    arg1: any; arg2: any; arg3: any;
    css: string;
    public TestInfo; public SectionInfo; public QItems;
    public elem;
    public valid = true;
    public SectionDetailsList: any = [];
    public Preferences: any;
    public TestPrefController: any;
    public callConfirm: any;
    public CallClickEvents: any;
    public CallConfirm: any;
    public CallConfirmSubmit: any;
    public isHtmlRendered: boolean = false;
    public appPath: any = myGlobals.appPath;
    public testData: any;
    public headerHtml: any;
    public sectionInstructionHtml: any;
    public showNextSectionInstruciton: boolean = true;
    public pageNo: any = 0; public endPageNo: any;
    public totalQuestionCount: any = 0;
    public isEndExam: boolean = false;
    public EndExamMessages: any = 0;
    public EndPracticeExam: any;
    public ResumeExam: any;
    public ForceEndExam: any;
    public resultSummary: any;
    public totalGMATscore: any = 0;
    public totalGMATPercentile: any = 0;
    public GMATSectionScore;
    public mnpageNo: any = 1;
    public UserResponseObject: any;
    public bookMarkElement: any = null;
    public endSectionViewed: any = 0;
    public editorValue: string = '';
    public solutionSectionInfo: any = [];
    public NavigateToNextQuestion: any;
    public isActiveIrSection: any = false;
    public IsScreenPaused: boolean = false;
    public TimeToRestartAfterPause: any;
    private isQnsNumShown: boolean = false;
    private isTimeShown: boolean = false;
    public isTimeOut: any = false;
    public isPreviuousSectionTimeOut: boolean = false;
    public ActiveSectionId: any;
    public TargetSectionId: any;
    public isLastSection: any = false;
    public randomsections: any = false;
    public isAdaptiveQuestionReceived: boolean;
    public isNextClicked: boolean = false;
    public EndAdaptiveExam: any;
    public EndExamYesClicked: boolean = false;
    public SubmitExamYesClicked: boolean = false;
    public SectionTimeOutConfirmOk: any;
    public SectionTimeOutConfirmOkAdaptive: any;
    public isEnableSubmitButton: any = false;
    public IsShowNextReviewButton: boolean = false;
    public IsShowPreviousReviewButton: boolean = true;
    public NavigateToPreviousQuestion: any;
    public isSingleQuestion: any = "";
	public surveylink: any ="";
	public startpageno : any;
	public prevsecPno:any;
	public QuesNotAttempted:any;
    IsNextQuesTimer = false;
    public sectionReviewDetails;
    public InCompleteQuesCount: any = 0;
    public IsSingleQuesSection: boolean = true;
	public isReviewMode: boolean = false;
    public Rvwqueslist: any = [];
    public RPQuestIndex: any = 0;
	public startcount:any ;
	public endcount:any;
	public Review:boolean=true;
	public isPrevClicked: boolean = false;
    //public IsPageNumberAdded: boolean = false;
    public BuildVersion: any = 0;
    public SecName: any;
    public ckEditorConfig: {} = {
        "toolbarGroups": [
            { name: 'clipboard', groups: ['clipboard', 'undo'] }
        ],
        "removeButtons": "Source,Save,Templates,Find,Replace,Scayt,SelectAll"
    }
    public Test = {
        QuestionList: [],
        QuestionInfo: []
    }
    public timeoutTimer: any;
    public IsSectionChanged: any = false;
    public FeedBackVal: any = "";
    public OptionAreaVal: any = "";
    public Attributes = {
        spnImg: 'spnImg',
        spnSNA: 'spnSNA',
        navImg: 'navImg',
        navLi: 'navLi'
    }
	public SectionName: any;
	public TotalQuestions: any;
	public TotalTime: any;
    @ViewChild('dvreviewPop') reviewPopUp;
    @ViewChild('spnBookmark') spnbookmark;

    constructor(public assessmentService: ExamPlayerService) {

        this.loggedIn = true;
        //this.appPath = myGlobals.appPath;
        this.Preferences = $("#hdnObject").val();
        this.TestPrefController = $("#hdnTestPrefController").val();
        //this.GetQuestions();
    }
    ngOnInit() {
        try {
            $("#frmQuestion").show();
            $("#progress").show();
			if(this.mnpageNo == 1){ $("btnReviewPrevious").hide();}
            this.Preferences = JSON.parse(this.Preferences);
            this.TestInfo = this.Preferences;
            if (this.TestPrefController != null && this.TestPrefController != "")
            this.TestPrefController = JSON.parse(this.TestPrefController);
            this.LoadThemeCss(this.Preferences.StylesheetName.toLocaleLowerCase());
            if (this.TestInfo.Status == 2)
                this.GetSolutionQuestions();
            else {
                if (this.Preferences.Mode == 2)
                    this.GetTryoutQuestions();
                else {				
					 this.GetTestQuestions();					  
                }
            }
            this.AssignResouceKeyValue();
        }
        catch (e) { }
    }
    GetSolutionQuestions() {
        try {
            $("#lowerStrip").hide()
            $("#dvopacityscreen").show(); $("#timerHolder").hide();
            this.assessmentService.GetSolutionQuestions(this.Preferences.AssessmentID).subscribe(result => {
                var reponseData: any;
                reponseData = result;
                if (reponseData == null || reponseData.length == 0 || reponseData.d == "") {
                    alert("Solution Questions loading failed"); return
                }
                this.testData = JSON.parse(reponseData.d);
                if (this.testData.QuestionsData.lstQuestions.length == 0 || this.testData.QuestionsData.lstQuestions == null) {
                    alert("No Questions to display");
                    $("#progress").hide();
                    location.href = "TestReview.aspx";
                    return
                }
                this.TestInfo = this.testData.QuestionsData.Preferences;
                this.SectionInfo = this.testData.QuestionsData.TestDetails;
                this.QItems = this.testData.QuestionsData.lstQuestions;
                this.SectionDetailsList = this.ConstructSectionOjects(this.SectionInfo.Sections);
                this.SolutionSectionInit(this.SectionDetailsList);
                $("#timerHolder").hide(); $(".pullleft").show(); $(".hdnbtn").hide(); $(".pullright").hide(); $("#frmQuestion").show(); $("#progress").hide(); $("#dvopacityscreen").hide(); $("#lowerStrip").show();
            });
        }
        catch (e) { }
    }

    GetTestQuestions() {
        try {				
            this.assessmentService.GetTestQuestions(this.Preferences.AssessmentID).subscribe(result => {
                var reponseData: any;
                reponseData = result;
                if (reponseData == null || reponseData.length == 0 || reponseData.d == "") {
                    alert("Questions loading failed"); return
                }
                this.testData = JSON.parse(reponseData.d);
                this.TestInfo = this.testData.QuestionsData.Preferences;
                $("#hdnObject").val(JSON.stringify(this.TestInfo));
                this.SectionInfo = this.testData.QuestionsData.TestDetails;
                this.QItems = this.testData.QuestionsData.lstQuestions;
                this.SectionDetailsList = this.ConstructSectionOjects(this.SectionInfo.Sections);
                if (this.TestInfo.AssessmentTypeCode == "SELADAPTIVE") {
                    this.ValidateAdativeSectionQuestionOnTestStart(this.SectionDetailsList);					 
                }
                this.LoadExternalJSandCSS(this.testData.QuestionsData.TestDetails, this.testData.QuestionsData.Preferences.StylesheetName.toLocaleLowerCase());
                this.isSingleQuestion = isSingleQuestionPreview;
                $("#frmQuestion").show();
				$(".pullleft").css('display','none');
                $("#progress").hide(); $("#dvopacityscreen").hide();
            });
        }
        catch (e) { }
        $("#dvopacityscreen").show();
    }


    GetTryoutQuestions() {
        try {
            this.assessmentService.GetTryoutQuestions(this.Preferences.AssessmentID).subscribe(result => {
                var reponseData: any;
                reponseData = result;
                if (reponseData == null || reponseData.length == 0 || reponseData.d == "") {
                    alert("Questions loading failed"); return
                }
                this.testData = JSON.parse(reponseData.d);
                this.TestInfo = this.testData.QuestionsData.Preferences;
                $("#hdnObject").val(JSON.stringify(this.TestInfo));
                this.SectionInfo = this.testData.QuestionsData.TestDetails;
                this.QItems = this.testData.QuestionsData.lstQuestions;
                this.SectionDetailsList = this.ConstructSectionOjects(this.SectionInfo.Sections);
                if (this.TestInfo.AssessmentTypeCode == "SELADAPTIVE") {
                    this.ValidateAdativeSectionQuestionOnTestStart(this.SectionDetailsList);
                }
                this.LoadExternalJSandCSS(this.testData.QuestionsData.TestDetails, this.testData.QuestionsData.Preferences.StylesheetName.toLocaleLowerCase());
                this.isSingleQuestion = isSingleQuestionPreview;
                if (typeof (isSingleQuestionPreview) != "undefined" && isSingleQuestionPreview == "True") $('.tpl_qno_pad').css('display', 'none');
                $("#frmQuestion").show();
                $("#progress").hide(); $("#dvopacityscreen").hide();

            });
        }
        catch (e) { }
        $("#dvopacityscreen").show();
    }
    SolutionSectionInit(SectionDetailsList) {
        try {
            for (var i = 0; i < SectionDetailsList.length; i++) {
                this.solutionSectionInfo[SectionDetailsList[i].SectionID] = SectionDetailsList[i];
            }
        }
        catch (e) { }
    }
    ValidateAdativeSectionQuestionOnTestStart(SectionDetailsList) {
        try {
            for (var i = 0; i < SectionDetailsList.length; i++) {
                if (SectionDetailsList[i].SectionOrder == 1 && SectionDetailsList[i].SectionTypeCode != null && SectionDetailsList[i].SectionTypeCode == 'SAAIS01')
                    this.ActiveSectionId = SectionDetailsList[i].SectionID;
            }
        }
        catch (e) { }
    }

    EvaluateUserReponse(ctParent, item) {
        try {
            var selectDiv;
            let maInputs: any;
            switch (item.QType.toLocaleLowerCase()) {
                case 'multiple choice static':
                case 'true / false':
                case 'likert scale':
                    //                    var userchoice = $("div[CID='" + item.CorrectOptions[0], ctParent);
                    var htmlAdded = false;
                    var correctChoice = $("div[CID='" + item.CorrectOptions[0].Ident + "']", ctParent);
                    maInputs = $("input[question='true']:radio", ctParent);
                    var choiceArr = $("input[type='radio'][question='true']:checked", ctParent);
                    var span;
                    if (item.UserRepsonse == null || typeof (item.UserRepsonse) == 'undefined' || item.UserRepsonse.length == 0) {
                        $(choiceArr[0].parentElement.parentElement).addClass('correctanswer')
                        return;
                    } else {
                        span = document.createElement('span');
                        if ($(choiceArr).val() == item.CorrectOptions[0].Ident) {
                            $(choiceArr[0].parentElement.parentElement).addClass('correctanswer')
                            htmlAdded = true;
                        }
                        else
                            $(choiceArr[0].parentElement.parentElement).addClass('wronganswer')
                    }
                    span = document.createElement('span');
                    $.each(maInputs, function (index, ob) {
                        $(ob).attr("disabled", 'true');
                        if (!htmlAdded) {
                            $(ob).val() == item.CorrectOptions[0].Ident ? $(ob.parentElement.parentElement).addClass('correctanswer') : "";
                        }
                    })
                    return;
                case "multiple response static":
                    var htmlAdded = false;
                    var correctChoice = $("div[CID='" + item.CorrectOptions[0].Ident + "']", ctParent);
                    maInputs = $("input[question='true']:checkbox", ctParent);
                    var choiceArr = $("input[type='checkbox'][question='true']:checked", ctParent);
                    var span;
                    if (item.UserRepsonse == null || typeof (item.UserRepsonse) == 'undefined' || item.UserRepsonse.length == 0) {
                        for (var i = 0; i < choiceArr.length; i++) {
                            $(choiceArr[i].parentElement.parentElement).addClass('correctanswer')
                        }
                        return;
                    } else {
                        span = document.createElement('span');
                        for (var i = 0; i < choiceArr.length; i++) {
                            for (var cr = 0; cr < item.CorrectOptions.length; cr++) {
                                if ($(choiceArr[i]).val() == item.CorrectOptions[cr].Ident) {
                                    $(choiceArr[i].parentElement.parentElement).addClass('correctanswer')
                                    htmlAdded = true;
                                }
                                else
                                    $(choiceArr[i].parentElement.parentElement).addClass('wronganswer')
                            }
                        }

                    }
                    span = document.createElement('span');
                    $.each(maInputs, function (index, ob) {
                        $(ob).attr("disabled", 'true');
                        if (!htmlAdded) {
                            for (var cr = 0; cr < item.CorrectOptions.length; cr++) {
                                $(ob).val() == item.CorrectOptions[cr].Ident ? $(ob.parentElement.parentElement).addClass('correctanswer') : "";
                            }
                        }
                    })
                    return;
                case "situational judgement type":
                    maInputs = $("input[question='true']:radio", ctParent);
                    $.each(maInputs, function (index, ob) {
                        $(ob).attr("disabled", 'true');
                    })
                    for (var i = 0; item.CorrectOptions != null && i < item.CorrectOptions.length; i++) {
                        var isTrue = false, htmlAdded = false, isRightAdded = false;
                        try {
                            if (item.UserRepsonse == null || typeof (item.UserRepsonse) == 'undefined' || item.UserRepsonse.length == 0) {
                                $('input[solutionid=' + item.CorrectOptions[i].id + item.CorrectOptions[i].Ident + ']', ctParent).addClass("input_sel");
                                $($('input[solutionid=' + item.CorrectOptions[i].id + item.CorrectOptions[i].Ident + ']', ctParent)[0].parentElement).prepend('<span class="statusright_l"></div>');
                                continue;
                            }
                            $.each(item.UserRepsonse, function (index, value) {
                                $('input[solutionid=' + value.split(':')[0] + value.split(':')[1] + ']', ctParent).attr("checked", "true");
                                if (item.CorrectOptions[i].ID == value.split(':')[0] && item.CorrectOptions[i].Ident == value.split(':')[1]) {
                                    $('input[solutionid=' + value.split(':')[0] + value.split(':')[1] + ']', ctParent).addClass("input_sel");
                                    $($('input[solutionid=' + value.split(':')[0] + value.split(':')[1] + ']', ctParent)[0].parentElement).prepend('<span class="statusright_l"></div>');
                                    isTrue = true; isRightAdded = true;
                                }
                            });
                        }
                        catch (Ex) {
                            //$($('input[solutionid=' + value.split('$')[0] + value.split('$')[1] + ']', ctParent)[0].parentElement).prepend('<span class="statusright_l"></div>');
                            //isTrue = true;
                        }
                        try {
                            if (!isTrue) {
                                $.each(item.UserRepsonse, function (index, value) {
                                    if (value.split(':')[1] == item.CorrectOptions[i].Ident && htmlAdded == false && item.QuestionAttributes.Cardinality == "single") {
                                        if (!isRightAdded) {
                                            if (item.CorrectOptions[i].ID + ':' + item.CorrectOptions[i].Ident != value) $($('input[solutionid=' + value.split(':')[0] + value.split(':')[1] + ']', ctParent)[0].parentElement).prepend('<span class="statuswrong_l"></div>');
                                            $('input[solutionid=' + value.split(':')[0] + value.split(':')[1] + ']', ctParent).addClass("input_sel");
                                        }
                                        $($('input[solutionid=' + item.CorrectOptions[i].ID + item.CorrectOptions[i].Ident + ']', ctParent)[0].parentElement).prepend('<span class="statusright_l"></div>');
                                        $('input[solutionid=' + item.CorrectOptions[i].ID + item.CorrectOptions[i].Ident + ']', ctParent).addClass("input_sel");
                                        htmlAdded = true;
                                    }
                                    else if (value.split(':')[0] == item.CorrectOptions[i].ID && htmlAdded == false && item.QuestionAttributes.Cardinality == "multiple") {
                                        if (!isRightAdded) {
                                            if (item.CorrectOptions[i].ID + ':' + item.CorrectOptions[i].Ident != value) $($('input[solutionid=' + value.split(':')[0] + value.split(':')[1] + ']', ctParent)[0].parentElement).prepend('<span class="statuswrong_l"></div>');
                                            $('input[solutionid=' + value.split(':')[0] + value.split(':')[1] + ']', ctParent).addClass("input_sel");
                                        }
                                        $($('input[solutionid=' + item.CorrectOptions[i].ID + item.CorrectOptions[i].Ident + ']', ctParent)[0].parentElement).prepend('<span class="statusright_l"></div>');
                                        $('input[solutionid=' + item.CorrectOptions[i].ID + item.CorrectOptions[i].Ident + ']', ctParent).addClass("input_sel");
                                        htmlAdded = true;
                                    }
                                });
                            }
                            if (!isTrue && !htmlAdded) {
                                if (!isRightAdded && item.QuestionAttributes.Cardinality == "single") {
                                    for (var res = 0; res < item.UserRepsonse.length; res++) {
                                        if (item.UserRepsonse[res].split(':')[1] == item.CorrectOptions[i].Ident) {
                                            $($('input[solutionid=' + item.UserRepsonse[res].split(':')[0] + item.CorrectOptions[i].Ident + ']', ctParent)[0].parentElement).prepend('<span class="statuswrong_l"></div>');
                                            $('input[solutionid=' + item.UserRepsonse[res].split(':')[0] + item.CorrectOptions[i].Ident + ']', ctParent).addClass("input_sel");
                                        }
                                    }
                                }
                                else if (!isRightAdded) {
                                    $($('input[solutionid=' + item.UserRepsonse[i].split(':')[0] + item.UserRepsonse[i].split(':')[1] + ']', ctParent)[0].parentElement).prepend('<span class="statuswrong_l"></div>');
                                    $('input[solutionid=' + item.UserRepsonse[i].split(':')[0] + item.UserRepsonse[i].split(':')[1] + ']', ctParent).addClass("input_sel");
                                }
                                $($('input[solutionid=' + item.CorrectOptions[i].ID + item.CorrectOptions[i].Ident + ']', ctParent)[0].parentElement).prepend('<span class="statusright_l"></div>');
                                $('input[solutionid=' + item.CorrectOptions[i].ID + item.CorrectOptions[i].Ident + ']', ctParent).addClass("input_sel");
                            }

                        }
                        catch (ex) {
                        }

                    }
                    break;
                case "select a blank":
                case "matching":
                case "pull down list":
                case "ranking":

                    if (item.QType.toLocaleLowerCase() != "ranking") {
                        $($(".question_fib_span", ctParent)[0]).append($.parseHTML(item.Text));
                    }
                    maInputs = $("select[id='" + item.ID + "'][question='true']", ctParent);
                    for (var chIndex = 0; chIndex < item.Choices.length; chIndex++) {
                        for (var i = 0; item != null && i < item.CorrectOptions.length; i++) {
                            var isTrue = false;
                            if (item.UserRepsonse == null || typeof (item.UserRepsonse) == 'undefined' || item.UserRepsonse.length == 0) {
                                var html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li> <li class="correctanswer"><span><b>' + item.CorrectOptions[i].Ident + '</b></span></li><ul>'
                                if (item.QType.toLocaleLowerCase() == "matching" || item.QType.toLocaleLowerCase() == "pull down list") {
                                    selectDiv = $("select[cid='" + item.CorrectOptions[i].ID + "'")
                                    html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li> <li class="correctanswer"><span><b>' + this.GetChoiceText(4, item, item.CorrectOptions[i].Ident) + '</b></span></li><ul>'
                                }
                                else if (item.QType.toLocaleLowerCase() == "ranking") {
                                    selectDiv = $("select[cid='" + item.CorrectOptions[i].ID + "'")
                                    html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li> <li class="correctanswer"><span><b>' + this.GetChoiceText(5, item, item.CorrectOptions[i].Ident) + '</b></span></li><ul>'
                                }
                                else
                                    selectDiv = $("#" + item.CorrectOptions[i].ID)[0];
                                $(html).insertAfter(selectDiv);
                                if (selectDiv.length > 0) $(selectDiv)[0].remove();
                                item.CorrectOptions[i] = "";
                                continue;
                            }
                            try {
                                for (res of item.UserRepsonse) {
                                    if (item.CorrectOptions[i].ID == (<any>res).split(':')[0] && item.CorrectOptions[i].Ident == (<any>res).split(':')[1] && isTrue == false) {
                                        var html = '<ul class="clsSolution"><li class="correctanswer"><span>' + (<any>res).split(':')[1] + '</b></span></li><ul>'
                                        if (item.QType.toLocaleLowerCase() == "matching" || item.QType.toLocaleLowerCase() == "pull down list") {
                                            selectDiv = $("select[cid='" + (<any>res).split(':')[0] + "'")
                                            html = '<ul class="clsSolution"><li class="correctanswer"><span>' + this.GetChoiceText(4, item, (<any>res).split(':')[1]) + '</b></span></li><ul>'
                                        }
                                        else if (item.QType.toLocaleLowerCase() == "ranking") {
                                            selectDiv = $("select[cid='" + (<any>res).split(':')[0] + "'")
                                            html = '<ul class="clsSolution"><li class="correctanswer"><span>' + this.GetChoiceText(5, item, (<any>res).split(':')[1]) + '</b></span></li><ul>'
                                        }
                                        else
                                            selectDiv = $("#" + (<any>res).split(':')[0])[0];
                                        $(html).insertAfter(selectDiv); if (selectDiv.length > 0) $(selectDiv)[0].remove();
                                        res = 0; item.CorrectOptions[i] = "";
                                        isTrue = true;

                                    }
                                }
                            }
                            catch (e) {
                                isTrue = true;
                                var html = '<ul  class="clsSolution"><li class="wronganswer"></li><li class="correctanswer"><span><b>' + item.CorrectOptions[i].Ident + '</b></span></li></ul>';
                                if (item.QType.toLocaleLowerCase() == "matching" || item.QType.toLocaleLowerCase() == "pull down list") {
                                    selectDiv = $("select[cid='" + item.CorrectOptions[i].ID + "'")
                                    html = '<ul  class="clsSolution"><li class="wronganswer"> </li><li class="correctanswer"><span><b>' + this.GetChoiceText(4, item, item.CorrectOptions[i].Ident) + '</b></span></li></ul>';
                                }
                                else if (item.QType.toLocaleLowerCase() == "ranking") {
                                    selectDiv = $("select[cid='" + item.CorrectOptions[i].ID + "'")
                                    html = '<ul  class="clsSolution"><li class="wronganswer"> </li><li class="correctanswer"><span><b>' + this.GetChoiceText(5, item, item.CorrectOptions[i].Ident) + '</b></span></li></ul>';
                                }
                                else
                                    selectDiv = $("#" + item.CorrectOptions[i].ID)[0];
                                $(html).insertAfter(selectDiv);
                                if (selectDiv.length > 0) $(selectDiv)[0].remove();
                                item.CorrectOptions[i] = "";
                            }
                            try {
                                if (!isTrue) {
                                    var htmlAdded = false;
                                    for (res of item.UserRepsonse) {
                                        if ((<any>res).split(':')[0] == item.CorrectOptions[i].ID && htmlAdded == false) {
                                            var html = '<ul  class="clsSolution"><li class="wronganswer">   <span ><b>' + (<any>res).split(':')[1] + '</b> </span></li><li class="correctanswer"><span><b>' + item.CorrectOptions[i].Ident + '</b></span></li></ul>';
                                            if (item.QType.toLocaleLowerCase() == "matching" || item.QType.toLocaleLowerCase() == "pull down list") {
                                                selectDiv = $("select[cid='" + item.CorrectOptions[i].ID + "'")
                                                html = '<ul  class="clsSolution"><li class="wronganswer">   <span ><b>' + this.GetChoiceText(4, item, (<any>res).split(':')[1]) + '</b> </span></li><li class="correctanswer"><span><b>' + this.GetChoiceText(4, item, item.CorrectOptions[i].Ident) + '</b></span></li></ul>';
                                            }
                                            else if (item.QType.toLocaleLowerCase() == "ranking") {
                                                selectDiv = $("select[cid='" + item.CorrectOptions[i].ID + "'")
                                                html = '<ul  class="clsSolution"><li class="wronganswer">   <span ><b>' + this.GetChoiceText(5, item, (<any>res).split(':')[1]) + '</b> </span></li><li class="correctanswer"><span><b>' + this.GetChoiceText(5, item, item.CorrectOptions[i].Ident) + '</b></span></li></ul>';
                                            }
                                            else
                                                selectDiv = $("#" + item.CorrectOptions[i].ID)[0];
                                            $(html).insertAfter(selectDiv);
                                            if (selectDiv.length > 0) $(selectDiv)[0].remove();
                                            htmlAdded = true;

                                        }
                                    }
                                }
                            }
                            catch (e) {
                            }
                            if (!isTrue && htmlAdded == false) {
                                var html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li> <li class="correctanswer"><span><b>' + item.CorrectOptions[i].Ident + '</b></span></li><ul>'
                                if (item.QType.toLocaleLowerCase() == "matching" || item.QType.toLocaleLowerCase() == "pull down list") {
                                    selectDiv = $("select[cid='" + item.CorrectOptions[i].ID + "'")
                                    html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li> <li class="correctanswer"><span><b>' + this.GetChoiceText(4, item, item.CorrectOptions[i].Ident) + '</b></span></li><ul>'
                                }
                                else if (item.QType.toLocaleLowerCase() == "ranking") {
                                    selectDiv = $("select[cid='" + item.CorrectOptions[i].ID + "'")
                                    html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li> <li class="correctanswer"><span><b>' + this.GetChoiceText(5, item, item.CorrectOptions[i].Ident) + '</b></span></li><ul>'
                                }
                                else
                                    selectDiv = $("#" + item.CorrectOptions[i].ID)[0];
                                $(html).insertAfter(selectDiv);
                                if (selectDiv.length > 0) $(selectDiv)[0].remove();
                                item.CorrectOptions[i] = "";
                            }
                        }
                    }

                    break;
                case "image labeling drag and drop":
                case "matching drag and drop":
                    var userres;
                    for (var chIndex = 0; chIndex < item.Choices.length; chIndex++) {
                        for (var i = 0; item != null && i < item.CorrectOptions.length; i++) {
                            var isTrue = false;
                            if (item.UserRepsonse == null || typeof (item.UserRepsonse) == 'undefined' || item.UserRepsonse.length == 0) {
                                if (item.QType.toLocaleLowerCase() == "matching drag and drop")
                                    var html = '<div class="machSlondiv"><div class="question_matching_dnd_op na"><span class="class="question_matching_op"><b></b></span></div> <div class="question_matching_dnd_op correctanswer"><span>' + this.GetChoiceText(3, item, item.CorrectOptions[i].Ident) + '</span></div></div>'
                                else
                                    var html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li> <li class="correctanswer"><span><b>' + item.CorrectOptions[i].OptionsText + '</b></span></li><ul>'
                                if (item.QType.toLocaleLowerCase() == "matching drag and drop")
                                    selectDiv = $("div[id='" + item.CorrectOptions[i].ID + 'dnd' + item.CorrectOptions[i].Ident + '_Drop' + "']", ctParent);
                                else
                                    selectDiv = $("div[id='" + item.ID + 'dnd' + item.CorrectOptions[i].Ident + '_Drop' + "'][blankdiv='true']", ctParent);
                                $(html).insertAfter($(selectDiv));
                                if ($(selectDiv).length > 0) $(selectDiv).remove();
                                item.CorrectOptions[i] = "";
                                continue;
                            }
                            try {
                                for (res of item.UserRepsonse) {
                                    if (item.CorrectOptions[i].ID == (<any>res).split(':')[0] && item.CorrectOptions[i].Ident == (<any>res).split(':')[1] && isTrue == false) {

                                        if (item.QType.toLocaleLowerCase() == "matching drag and drop") {
                                            selectDiv = $("div[id='" + (<any>res).split(':')[0] + 'dnd' + (<any>res).split(':')[1] + '_Drop' + "']", ctParent);
                                            var html = '<div class="machSlondiv"><div class="question_matching_dnd_op correctanswer"><span>' + this.GetChoiceText(2, item, (<any>res)) + '</span></div></div>'
                                        }
                                        else {
                                            var html = '<ul class="clsSolution"><li class="correctanswer"><span>' + this.GetChoiceText(1, item, (<any>res)) + '</b></span></li><ul>'
                                            selectDiv = $("div[id='" + item.ID + 'dnd' + (<any>res).split(':')[1] + '_Drop' + "'][blankdiv='true']", ctParent);
                                        }
                                        $(html).insertAfter($(selectDiv));
                                        if ($(selectDiv).length > 0) $(selectDiv).remove();
                                        res = 0; item.CorrectOptions[i] = "";
                                        isTrue = true;

                                    }
                                };
                            }
                            catch (ex) {
                                isTrue = true;
                                var html = '<ul class="clsSolution"><li class="correctanswer"><span>' + item.CorrectOptions[i].OptionsText + '</b></span></li><ul>'
                                if (item.QType.toLocaleLowerCase() == "matching drag and drop") {
                                    html = '<div class="machSlondiv"><div class="question_matching_dnd_op correctanswer"><span>' + this.GetChoiceText(3, item, item.CorrectOptions[i].Ident) + '</span></div></div>'
                                    selectDiv = $("div[id='" + item.CorrectOptions[i].ID + 'dnd' + item.CorrectOptions[i].Ident + '_Drop' + "']", ctParent);
                                }
                                else
                                    selectDiv = $("div[id='" + item.ID + 'dnd' + item.CorrectOptions[i].Ident + '_Drop' + "'][blankdiv='true']", ctParent);

                                $(html).insertAfter($(selectDiv));
                                if ($(selectDiv).length > 0) $(selectDiv).remove();
                                item.CorrectOptions[i] = "";
                            }
                            try {
                                if (!isTrue) {
                                    var htmlAdded = false;
                                    for (res of item.UserRepsonse) {
                                        if ((<any>res).split(':')[0] == item.CorrectOptions[i].ID && htmlAdded == false) {

                                            if (item.QType.toLocaleLowerCase() == "matching drag and drop") {
                                                var html = '<div class="machSlondiv"><div class="question_matching_dnd_op wronganswer"><span>' + this.GetChoiceText(2, item, (<any>res)) + '</span></div> <div class="question_matching_dnd_op correctanswer"><span><b>' + this.GetChoiceText(3, item, item.CorrectOptions[i].Ident) + '</b></span></div></div>'
                                                selectDiv = $("div[id='" + item.CorrectOptions[i].ID + 'dnd' + item.CorrectOptions[i].Ident + '_Drop' + "']", ctParent);
                                            }
                                            else {
                                                var html = '<ul class="clsSolution"><li class="wronganswer"><span><b>' + this.GetChoiceText(1, item, (<any>res)) + '</b></span></li> <li class="correctanswer"><span><b>' + item.CorrectOptions[i].OptionsText + '</b></span></li><ul>'
                                                selectDiv = $("div[id='" + item.ID + 'dnd' + item.CorrectOptions[i].Ident + '_Drop' + "'][blankdiv='true']", ctParent);
                                            }
                                            $(html).insertAfter($(selectDiv));
                                            if ($(selectDiv).length > 0) $(selectDiv).remove();
                                            res = 0; item.CorrectOptions[i] = "";
                                            htmlAdded = true;

                                        }
                                    };
                                }
                            }
                            catch (Ex) {
                            }
                            if (!isTrue && htmlAdded == false) {
                                if (item.QType.toLocaleLowerCase() == "matching drag and drop")
                                    var html = '<div class="machSlondiv"><div class="question_matching_dnd_op na"><span class="class="question_matching_op"><b></b></span></div> <div class="question_matching_dnd_op correctanswer"><span>' + this.GetChoiceText(3, item, item.CorrectOptions[i].Ident) + '</span></div></div>'
                                else
                                    var html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li> <li class="correctanswer"><span><b>' + item.CorrectOptions[i].OptionsText + '</b></span></li><ul>'
                                if (item.QType.toLocaleLowerCase() == "matching drag and drop")
                                    selectDiv = $("div[id='" + item.CorrectOptions[i].ID + 'dnd' + item.CorrectOptions[i].Ident + '_Drop' + "']", ctParent);
                                else
                                    selectDiv = $("div[id='" + item.ID + 'dnd' + item.CorrectOptions[i].Ident + '_Drop' + "'][blankdiv='true']", ctParent);
                                $(html).insertAfter($(selectDiv));
                                if ($(selectDiv).length > 0) $(selectDiv).remove();
                                item.CorrectOptions[i] = "";
                            }
                        }
                        $("div[class='move_icon']", ctParent).hide();
                    }
                    break;
                case "image labeling entry":
                case "entry list static":
                case "fill in blanks static":
                    maInputs = $("input[type='text'][question='true']", ctParent);
                    if (item.QType.toLocaleLowerCase() == 'fill in blanks static')
                        $("span[class='question_fib_span']", ctParent).html(item.Text);
                    for (var chIndex = 0; chIndex < item.Choices.length; chIndex++) {
                        for (var i = 0; item != null && i < item.CorrectOptions.length; i++) {
                            var isTrue = false;
                            if (item.UserRepsonse == null || typeof (item.UserRepsonse) == 'undefined' || item.UserRepsonse.length == 0) {
                                if (item.QType.toLocaleLowerCase() == "entry list static")
                                    var html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li> <li class="correctanswer"><span><b>' + item.CorrectOptions[i].Ident + '</b></span></li><ul>'
                                else
                                    var html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li> <li class="correctanswer"><span><b>' + item.CorrectOptions[i].OptionsText + '</b></span></li><ul>'
                                selectDiv = $("input[type='text'][question='true'][name='" + item.ID + '$' + item.CorrectOptions[i].ID + "']");
                                $(html).insertAfter($(selectDiv));
                                if ($(selectDiv).length > 0) $(selectDiv).remove();
                                item.CorrectOptions[i] = "";
                                continue;
                            }
                            try {
                                $.each(item.UserRepsonse, function (index, value) {
                                    var correctAns, UserAns;
                                    if (item.CorrectOptions[i].IsCaseSensitive) {
                                        correctAns = item.CorrectOptions[i].Ident;
                                        UserAns = value.split(':')[1];
                                    }
                                    else {
                                        correctAns = item.CorrectOptions[i].Ident.toLocaleLowerCase();
                                        UserAns = value.split(':')[1].toLocaleLowerCase();
                                    }

                                    if (item.CorrectOptions[i].ID == value.split(':')[0] && correctAns == UserAns && isTrue == false) {
                                        var userRes = value.split(':')[1];
                                        var html = '<ul class="clsSolution"><li class="correctanswer"><span><b>' + userRes + '</b></span></li><ul>'
                                        selectDiv = $("input[type='text'][question='true'][name='" + item.ID + '$' + value.split(':')[0] + "']");
                                        $(html).insertAfter($(selectDiv));
                                        if ($(selectDiv).length > 0) $(selectDiv).remove();
                                        value = ""; item.CorrectOptions[i] = "";
                                        isTrue = true;

                                    }
                                });
                            }
                            catch (ex) {
                                isTrue = true;
                                if (item.QType.toLocaleLowerCase() == "entry list static")
                                    var html = '<ul class="clsSolution"><li class="correctanswer"><span><b>' + item.CorrectOptions[i].Ident + '</b></span></li><ul>'
                                else
                                    var html = '<ul class="clsSolution"><li class="correctanswer"><span><b>' + item.CorrectOptions[i].OptionsText + '</b></span></li><ul>'
                                selectDiv = $("input[type='text'][question='true'][name='" + item.ID + '$' + item.CorrectOptions[i].ID + "']");
                                $(html).insertAfter($(selectDiv));
                                if ($(selectDiv).length > 0) $(selectDiv).remove();
                                item.CorrectOptions[i] = "";
                            }
                            try {
                                if (!isTrue) {
                                    var htmlAdded = false;
                                    $.each(item.UserRepsonse, function (index, value) {
                                        if (value.split(':')[0] == item.CorrectOptions[i].ID && htmlAdded == false) {
                                            var userRes = value.split(':')[1];
                                            selectDiv = $("input[type='text'][question='true'][name='" + item.ID + '$' + item.CorrectOptions[i].ID + "']");
                                            if (item.QType.toLocaleLowerCase() == "entry list static")
                                                var html = '<ul class="clsSolution"><li class="wronganswer"><span><b>' + userRes + '</b></span></li><li class="correctanswer"><span><b>' + item.CorrectOptions[i].Ident + '</b></span></li><ul>'
                                            else
                                                var html = '<ul class="clsSolution"><li class="wronganswer"><span><b>' + userRes + '</b></span></li><li class="correctanswer"><span><b>' + item.CorrectOptions[i].OptionsText + '</b></span></li><ul>'
                                            $(html).insertAfter($(selectDiv));
                                            if ($(selectDiv).length > 0) $(selectDiv).remove();
                                            value = ""; item.CorrectOptions[i] = "";
                                            htmlAdded = true;

                                        }
                                    });
                                }
                            }
                            catch (Ex) {
                            }
                            if (!isTrue && htmlAdded == false) {
                                if (item.QType.toLocaleLowerCase() == "entry list static")
                                    var html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li><li class="correctanswer"><span><b>' + item.CorrectOptions[i].Ident + '</b></span></li><ul>'
                                else
                                    var html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li> <li class="correctanswer"><span><b>' + item.CorrectOptions[i].OptionsText + '</b></span></li><ul>'
                                selectDiv = $("input[type='text'][question='true'][name='" + item.ID + '$' + item.CorrectOptions[i].ID + "']");
                                $(html).insertAfter($(selectDiv));
                                if ($(selectDiv).length > 0) $(selectDiv).remove();
                                item.CorrectOptions[i] = "";
                            }
                        }
                    }
                    break;
                case "image labeling selection":
                    maInputs = $("select[id='" + item.ID + "'][question='true']", ctParent);
                    for (var chIndex = 0; chIndex < item.Choices.length; chIndex++) {
                        for (var i = 0; item != null && i < item.CorrectOptions.length; i++) {
                            var isTrue = false;
                            if (item.UserRepsonse == null || typeof (item.UserRepsonse) == 'undefined' || item.UserRepsonse.length == 0) {
                                var html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li> <li class="correctanswer"><span><b>' + item.CorrectOptions[i].OptionsText + '</b></span></li><ul>'
                                selectDiv = $("select[name='" + item.ID + '$' + item.CorrectOptions[i].ID + "'][question='true']", ctParent)[0];
                                $(html).insertAfter($(selectDiv));
                                if ($(selectDiv).length > 0) $(selectDiv).remove();
                                item.CorrectOptions[i] = "";
                                continue;
                            }
                            try {
                                $.each(item.UserRepsonse, function (index, value) {
                                    if (item.CorrectOptions[i].ID == value.split(':')[0] && item.CorrectOptions[i].Ident == value.split(':')[1] && isTrue == false) {
                                        var userRes = $("option[selected='true']", $("select[name='" + item.ID + '$' + value.split(':')[0] + "'][question='true']", ctParent)[0]).html();
                                        var html = '<ul class="clsSolution"><li class="correctanswer"><span><b>' + userRes + '</b></span></li><ul>'
                                        selectDiv = $("select[name='" + item.ID + '$' + value.split(':')[0] + "'][question='true']", ctParent)[0];
                                        $(html).insertAfter($(selectDiv));
                                        if ($(selectDiv).length > 0) $(selectDiv).remove();
                                        value = ""; item.CorrectOptions[i] = "";
                                        isTrue = true;

                                    }
                                });
                            }
                            catch (ex) {
                                isTrue = true;
                                var html = '<ul class="clsSolution"><li class="correctanswer"><span><b>' + item.CorrectOptions[i].OptionsText + '</b></span></li><ul>'
                                selectDiv = $("select[name='" + item.ID + '$' + item.CorrectOptions[i].ID + "'][question='true']", ctParent)[0];
                                $(html).insertAfter($(selectDiv));
                                if ($(selectDiv).length > 0) $(selectDiv).remove();
                                item.CorrectOptions[i] = "";
                            }
                            try {
                                if (!isTrue) {
                                    var htmlAdded = false;
                                    $.each(item.UserRepsonse, function (index, value) {
                                        if (value.split(':')[0] == item.CorrectOptions[i].ID && htmlAdded == false) {
                                            var userRes = $("option[selected='true']", $("select[name='" + item.ID + '$' + value.split(':')[0] + "'][question='true']", ctParent)[0]).html();
                                            var html = '<ul class="clsSolution"><li class="wronganswer"><span><b>' + userRes + '</b></span></li><li class="correctanswer"><span><b>' + item.CorrectOptions[i].OptionsText + '</b></span></li><ul>'
                                            selectDiv = $("select[name='" + item.ID + '$' + item.CorrectOptions[i].ID + "'][question='true']", ctParent)[0];
                                            $(html).insertAfter($(selectDiv));
                                            if ($(selectDiv).length > 0) $(selectDiv).remove();
                                            value = ""; item.CorrectOptions[i] = "";
                                            htmlAdded = true;

                                        }
                                    });
                                }
                            }
                            catch (Ex) {
                            }
                            if (!isTrue && htmlAdded == false) {
                                var html = '<ul class="clsSolution"><li class="na"><span class="question_matching_op"><b></b></span></li> <li class="correctanswer"><span><b>' + item.CorrectOptions[i].OptionsText + '</b></span></li><ul>'
                                selectDiv = $("select[name='" + item.ID + '$' + item.CorrectOptions[i].ID + "'][question='true']", ctParent)[0];
                                $(html).insertAfter($(selectDiv));
                                if ($(selectDiv).length > 0) $(selectDiv).remove();
                                item.CorrectOptions[i] = "";
                            }
                        }
                    }
                    break;
                case "numeric":
                    var isCorrect = false, correctAns = "", symbl = "";
                    if (item.CorrectOptions != null && item.UserRepsonse != null) {
                        for (var i = 0; i < item.CorrectOptions.length; i++) {
                            $.each(item.UserRepsonse, function (index, value) {
                                if (value.split(':')[0] == item.CorrectOptions[i].ID && parseFloat(value.split(':')[1]) <= parseFloat(item.CorrectOptions[i].OptionsText)) {
                                    isCorrect = true;
                                }
                                if (i != item.CorrectOptions.length - 1) {
                                    (i < item.CorrectOptions.length - 2) ? symbl = '>=' : symbl = '<='
                                }
                                else symbl = "";
                                correctAns += item.CorrectOptions[i].OptionsText + symbl;
                            });
                        }
                        if (isCorrect)
                            $('input[type=text]', ctParent).replaceWith('<span class="lrn_clozedropdown_answer" style="display:webkit-inline-box">  <span ><b>' + item.UserRepsonse[0].split(':')[1] + '</b></span> </span>');
                        else
                            $('input[type=text]', ctParent).replaceWith('<span style="display:webkit-inline-box">  <span class="lrn_clozedropdown_answer wrong"><b>' + item.UserRepsonse[0].split(':')[1] + '</b> </span><span class="lrn_clozedropdown_answer"><span style="padding-left:0%"><b>' + correctAns + '</b></span></span>');
                    }
                    break;
                case "fib drag and drop":
                    var correctAns = "", isTrue = false;
                    if (item.UserRepsonse != null && typeof (item.UserRepsonse) != 'undefined' && item.UserRepsonse.length > 0) {
                        for (var res = 0; res < item.UserRepsonse.length; res++) {
                            for (var ch = 0; ch < item.CorrectOptions.length; ch++) {
                                if (item.UserRepsonse[res].split(':')[0] == item.CorrectOptions[ch].ID && item.UserRepsonse[res].split(':')[1] == item.CorrectOptions[ch].Ident) {
                                    $('#questionDiv.Questionarea').html($('#questionDiv.Questionarea').html().replace('@^^Blank_' + item.CorrectOptions[ch].ID + '^^@', '<div class="clsSolution"><div class="correctanswer"><span><b>' + item.CorrectOptions[ch].OptionsText + '</b> </span></div></div>'));
                                    isTrue = true;
                                }
                                if (!isTrue) {
                                    if (item.UserRepsonse[res].split(':')[0] == item.CorrectOptions[ch].ID) {
                                        for (var op = 0; op < item.Choices.length; op++) {
                                            if (item.Choices[op].Ident == item.UserRepsonse[res].split(':')[1]) {
                                                $('#questionDiv.Questionarea').html($('#questionDiv.Questionarea').html().replace('@^^Blank_' + item.UserRepsonse[res].split(':')[0] + '^^@', '<div class="clsSolution"><div class="wronganswer"><span><b>' + item.Choices[op].Text + '</b> </span></div> <div class="correctanswer"><span><b>' + item.CorrectOptions[ch].OptionsText + '</b></span></div></div>'));
                                            }
                                        }
                                    }
                                }
                            }
                            isTrue = false;
                        }
                    }
                    if ($('#questionDiv.Questionarea').html().indexOf('@^^Blank') != -1) {
                        for (var ch = 0; ch < item.CorrectOptions.length; ch++) {
                            if ($('#questionDiv.Questionarea').html().indexOf("@^^Blank_" + item.CorrectOptions[ch].ID + "^^@") != -1) {
                                for (var ch1 = 0; ch1 < item.Choices.length; ch1++) {
                                    if (item.Choices[ch1].ID == item.CorrectOptions[ch].ID && item.Choices[ch1].Ident == item.CorrectOptions[ch].Ident) {
                                        $('#questionDiv.Questionarea').html($('#questionDiv.Questionarea').html().replace("@^^Blank_" + item.Choices[ch1].ID + "^^@", '<div class="clsSolution"><div class="na"><span class="question_matching_op"><b></b></span></div> <div class="correctanswer"><span><b>' + item.CorrectOptions[ch].OptionsText + '</b></span></div></div>'));
                                    }
                                }
                            }
                        }
                    }
                    break;
                case "image labeling":
                    maInputs = $("div[id='dragableArea']", ctParent);
                    var isTrue = false;
                    if (item.UserRepsonse != null && typeof (item.UserRepsonse) != 'undefined' && item.UserRepsonse.length > 0) {
                        for (var ch = 0; ch < item.CorrectOptions.length; ch++) {
                            isTrue = false;
                            for (var res = 0; res < item.UserRepsonse.length; res++) {
                                if (item.CorrectOptions[ch].ID == item.UserRepsonse[res].split(':')[0]) {
                                    var optionHolderDiv = $("div[choiceid='" + item.ID + "dnd" + item.CorrectOptions[ch].ID + "']", maInputs);
                                    var answerOption = $("div.AnswerOption", optionHolderDiv);
                                    $("div.AnswerOption", optionHolderDiv).remove();
                                    if (item.CorrectOptions[ch].Ident == item.UserRepsonse[res].split(':')[1]) {
                                        var html = "<div class='useransDivIL correctanswer'>" + answerOption[0].outerHTML + "</div>";
                                        //html += "<div class='correctansDivIL'><div class='AnswerOption' value='" + item.CorrectOptions[ch].ID + ":" + item.CorrectOptions[ch].Ident + "'>" + item.CorrectOptions[ch].Ident + "</div></div>";
                                        $("div[choiceid='" + item.ID + "dnd" + item.CorrectOptions[ch].ID + "']", maInputs).append(html);
                                        isTrue = true;

                                    }
                                    else {
                                        var html = "<div class='useransDivIL wronganswer'>" + answerOption[0].outerHTML + "</div>";
                                        html += "<div class='correctansDivIL correctanswer'><div class='AnswerOption' value='" + item.CorrectOptions[ch].ID + ":" + item.CorrectOptions[ch].Ident + "'>" + item.CorrectOptions[ch].Ident + "</div></div>";
                                        $("div[choiceid='" + item.ID + "dnd" + item.CorrectOptions[ch].ID + "']", maInputs).append(html);
                                        isTrue = true;
                                    }
                                }
                            }
                            if (!isTrue) {
                                var optionHolderDiv = $("div[choiceid='" + item.ID + "dnd" + item.CorrectOptions[ch].ID + "']", maInputs);
                                var answerOption = $("div.AnswerOption", optionHolderDiv);
                                $("div.AnswerOption", optionHolderDiv).remove();
                                var html = "<div class='useransDivIL na'>" + answerOption[0].outerHTML + "</div>";
                                html += "<div class='correctansDivIL correctanswer'><div class='AnswerOption' value='" + item.CorrectOptions[ch].ID + ":" + item.CorrectOptions[ch].Ident + "'>" + item.CorrectOptions[ch].Ident + "</div></div>";
                                $("div[choiceid='" + item.ID + "dnd" + item.CorrectOptions[ch].ID + "']", maInputs).append(html);
                            }
                        }
                    }
                    else {
                        for (var ch = 0; ch < item.CorrectOptions.length; ch++) {
                            var optionHolderDiv = $("div[choiceid='" + item.ID + "dnd" + item.CorrectOptions[ch].ID + "']", maInputs);
                            var answerOption = $("div.AnswerOption", optionHolderDiv);
                            $("div.AnswerOption", optionHolderDiv).remove();
                            var html = "<div class='useransDivIL na'>" + answerOption[0].outerHTML + "</div>";
                            html += "<div class='correctansDivIL correctanswer'><div class='AnswerOption' value='" + item.CorrectOptions[ch].ID + ":" + item.CorrectOptions[ch].Ident + "'>" + item.CorrectOptions[ch].Ident + "</div></div>";
                            $("div[choiceid='" + item.ID + "dnd" + item.CorrectOptions[ch].ID + "']", maInputs).append(html);
                        }
                    }
                    break;
                case "text highlight":
                    var cardinality = $(".dvHighLight", ctParent).attr("rcardinality");
                    var outDiv = $(".dvHighLight", ctParent);
                    switch (cardinality.toLowerCase()) {
                        case "single":
                            if (item.UserRepsonse != null && item.UserRepsonse.length > 0) {
                                var userAnsSpan = $("span[id='" + item.UserRepsonse[0] + "']", outDiv);
                                $(userAnsSpan).toggleClass("classname");
                                $(userAnsSpan).toggleClass("HighLightSelected");
                            }
                            if (item.CorrectOptions != null && item.CorrectOptions.length > 0) {
                                var corSpan = $("span[id='" + item.CorrectOptions[0].Ident + "']", outDiv);
                                $(corSpan).wrap('<span class="correctanswer"></span>');
                            }
                            if (item.UserRepsonse != null && item.CorrectOptions != null && item.CorrectOptions.length > 0 && item.UserRepsonse.length > 0
                                && item.CorrectOptions[0].Ident != item.UserRepsonse[0]) {
                                $(userAnsSpan).wrap('<span class="wronganswer"></span>');
                            }
                            break;
                        case "multiple":
                            break;
                    }
                    $("span", outDiv).removeAttr("onclick");
                    break;
                default: break;
            }
        }
        catch (ex) { }
    }
	EvaluateUserReviewReponse(ctParent, item) {
	 try {
            switch (item.QType.toLocaleLowerCase()) {
			 case 'multiple choice static':                                                          
                    var maInputs = $("input[question='true']:radio", ctParent);
					 $.each(maInputs, function (index, ob) {
                        $(ob).attr("disabled", "true");
						$("ul[class='list-unstyled']", ctParent).attr("style","pointer-events: none;");	
						});
						break;
			 case "situational judgement type":
                    var maInputs = $("input[question='true']:radio", ctParent);				
                    $.each(maInputs, function (index, ob) {
                        $(ob).attr("disabled", "true");
						   $(item.ID).attr("style","pointer-events: none;");						
						$("input[type=radio]").attr('disabled', "true");
						$("table[class='SJTFCIMatrixTable']", ctParent).attr("style","pointer-events: none;");	
                    });					
					
					break;
			 case "select a blank":
                    $($(".checkbox-inline", ctParent)[0].children).remove();
                    $($(".checkbox-inline", ctParent)[0]).append($.parseHTML(item.Text));
                   /* var maInputs = $("select[id='" + item.ID + "'][question='true']", ctParent);
					for(var i=0;i<item.Choices.length;i++){
						$("select[id='" + item.Choices[i].ID + "'][question='true']", ctParent).attr('disabled', "true");
						}	*/			
                    break;
                case "essay":
                    try {
                        CKEDITOR.appendTo("EssayTextCKE" + item.ID, "", item.UserRepsonse);
                        CKEDITOR.config.readOnly = true;
                    }
                    catch (ex) { }
                    
			}
		}
		catch(e){}
					
	}

    GetChoiceText(type, item, choiceID): string {
        try {
            switch (type) {
                case 1:
                    for (var i = 0; i < item.Choices.length; i++) {
                        if (item.Choices[i].Ident == choiceID.split(':')[1])
                            return item.Choices[i].Text;
                    }
                    break;
                case 2:
                    for (var i = 0; i < item.options.length; i++) {
                        if (item.options[i].Ident == choiceID.split(':')[1])
                            return item.options[i].OptionsText;
                    }
                    break;
                case 3:
                    for (var i = 0; i < item.options.length; i++) {
                        if (item.options[i].Ident == choiceID)
                            return item.options[i].OptionsText;
                    }
                    break;
                case 4:
                    for (var i = 0; i < item.Choices[0].Options.length; i++) {
                        if (item.Choices[0].Options[i].Ident == choiceID)
                            return item.Choices[0].Options[i].OptionsText;
                    }
                    break;
                case 5:
                    for (var i = 0; i < item.Choices.length; i++) {
                        if (item.Choices[i].Ident == choiceID)
                            return item.Choices[i].OptionsText;
                    }
                    break;
                default:
                    for (var i = 0; i < item.Choices.length; i++) {
                        if (item.Choices[i].Ident == choiceID)
                            return item.Choices[i].OptionsText;
                    }
                    break;
            }
        }
        catch (e) { }
        return "";
    }
    LoadExternalJSandCSS(TestDetails, styleSheet) {
        try {
            var ExternalJSFileList = [], CssFileList = []
            // if (TestDetails.TestQTypes.indexOf(117))
            //  ExternalJSFileList.push('./Scripts/Slider.js?v=' + _buildVersion);
            if (TestDetails.TestQTypes.indexOf(30) > 0 || TestDetails.TestQTypes.indexOf(140) > 0) {
                ExternalJSFileList.push('./Script/Numbas.js?v=' + _buildVersion);
                ExternalJSFileList.push('./Script/ExprSimplify.js?v=' + _buildVersion);
            }
            if (TestDetails.TestQTypes.indexOf(87) > 0 || TestDetails.TestQTypes.indexOf(88) > 0 || TestDetails.TestQTypes.indexOf(89) > 0 || TestDetails.TestQTypes.indexOf(108) > 0 || TestDetails.TestQTypes.indexOf(111) > 0 || TestDetails.TestQTypes.indexOf(115) > 0 || TestDetails.TestQTypes.indexOf(117) > 0 || TestDetails.TestQTypes.indexOf(118) > 0 || TestDetails.TestQTypes.indexOf(119) > 0 || TestDetails.TestQTypes.indexOf(109) > 0) {
                ExternalJSFileList.push('./Script/EvaluateItemNew.js?v=' + _buildVersion);
                //ExternalJSFileList.push('./Scripts/jquery-ui-1.10.3.custom.min.js?v=' + _buildVersion);
                ExternalJSFileList.push('./Scripts/jquery.ui.touch-punch.js?v=' + _buildVersion);
            }
            if (TestDetails.TestQTypes.indexOf(35) > 0) {
                ExternalJSFileList.push('./Script/Voicelr/SarasVoiceClientCode/steal.js?SarasVoice.js?v=' + _buildVersion);
                ExternalJSFileList.push('./Script/Voicelr/Utils/common.js?v=' + _buildVersion);
            }
            if (TestDetails.TestQTypes.indexOf(120) > 0) {
                CssFileList.push("./Style/Handsontable.full.css?v=" + _buildVersion);
                ExternalJSFileList.push('./Script/ExcelGrid/jquery.handsontable.full.js?v=' + _buildVersion);
                ExternalJSFileList.push('./Script/ExcelGrid/highlight.pack.js');
            }
            if (TestDetails.TestQTypes.indexOf(121) > 0 || TestDetails.TestQTypes.indexOf(140) > 0) {
                CssFileList.push("./Script/MathML/Styles/MathML.css?v=" + _buildVersion);
                // ExternalJSFileList.push('./Script/MathML/Scripts/jquery-ui-1.10.3.custom.min.js?v=' + _buildVersion);
                ExternalJSFileList.push('./Script/MathML/Scripts/jquery.ui.touch-punch.js?v=' + _buildVersion);
                ExternalJSFileList.push('./Script/MathML/Scripts/MathML.js?v=' + _buildVersion);
                ExternalJSFileList.push('./Script/MathML/Scripts/MathMLExp.js?v=' + _buildVersion);
            }
            if (TestDetails.TestQTypes.indexOf(119) > 0)
                ExternalJSFileList.push('./Script/Crossword.js?v=' + _buildVersion);
            if (TestDetails.TestQTypes.indexOf(33) > 0 || TestDetails.TestQTypes.indexOf(157) > 0)
                ExternalJSFileList.push('./Script/angular.min.js?v=' + _buildVersion);
            if (TestDetails.TestQTypes.indexOf(121) > 0)
                ExternalJSFileList.push('./Editors/CKEditor/plugins/ckeditor_wiris/integration/WIRISplugins.js?v=' + _buildVersion);
            if (TestDetails.TestQTypes.indexOf(140) > 0 || TestDetails.TestQTypes.indexOf(30) > 0 || TestDetails.TestQTypes.indexOf(121) > 0 || TestDetails.TestQTypes.indexOf(146) > 0 || TestDetails.TestQTypes.indexOf(149) > 0 || TestDetails.TestQTypes.indexOf(150) > 0)
                ExternalJSFileList.push('./Editors/CKEditor/ckeditor.js?v=' + _buildVersion);
            //Loading JS and css files
            ExternalJSFileList.filter(function (obj) {
                var fileref = document.createElement('script');
                fileref.type = 'text/javascript';
                fileref.async = false;
                fileref.src = obj;
                var x = document.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(fileref, x);

            });
            CssFileList.filter(function (obj) {
                var fileref = document.createElement('link');
                fileref.rel = 'stylesheet';
                fileref.href = obj;
                fileref.media = 'all';
                fileref.type = 'text/css';
                var x = document.getElementsByTagName('head')[0];
                x.appendChild(fileref);

            });
        }
        catch (e) { }
    }
    LoadThemeCss(styleSheet) {
        try {
            var CssFileList = [];
            switch (styleSheet) {
                case "html5":
                    CssFileList.push("./Themes/HTML5/StyleSheet/styles_en.css?v=" + _buildVersion);
                    break;
                case "gray":
                    // CssFileList.push("./Themes/gray/StyleSheet/styles_en.css");
                    switch (userCutlure) {
                        case "ar":
                            CssFileList.push("./src/app/Test/Style/Src_styles_ar.css?v=" + _buildVersion);
                            break;
                        default:
                            CssFileList.push("./src/app/Test/Style/style_en.css?v=" + _buildVersion);
                            break;
                    }
                    break;
                case "deepblue":
                    CssFileList.push("./Themes/deepblue/StyleSheet/styles_en.css?v=" + _buildVersion);
                    CssFileList.push("./src/app/Test/Style/style_en.css?v=" + _buildVersion);
                    break;
                case "dodgerblue":
                    CssFileList.push("./src/app/Test/Style/style_en.css?v=" + _buildVersion);
                    break;
                case "sanmarino":
                    CssFileList.push("./Themes/SanMarino/StyleSheet/Styles_en.css?v=" + _buildVersion);
                    break;
                default:
                    CssFileList.push("./src/app/Test/Style/style_en.css?v=" + _buildVersion);
                    break;
            }
            CssFileList.filter(function (obj) {
                var fileref = document.createElement('link');
                fileref.rel = 'stylesheet';
                fileref.href = obj;
                fileref.media = 'all';
                fileref.type = 'text/css';
                var x = document.getElementsByTagName('head')[0];
                x.appendChild(fileref);

            });
        }
        catch (e) { }
    }
    GetRandomChoiceArray(RndNumbers) {
        try {
            var RandomArray = new Array();
            for (var mnIndex = 0; mnIndex < RndNumbers; mnIndex++) {
                var RndNumber;
                while (true) {
                    var isRpt = false;
                    RndNumber = Math.floor(Math.random() * RndNumbers + 1);
                    if (RndNumber == 0)
                        isRpt = true;
                    for (var rIndex = 0; rIndex < RandomArray.length; rIndex++)
                        if (RndNumber == RandomArray[rIndex] && RndNumber != 0)
                            isRpt = true;
                    if (!isRpt)
                        break;
                }
                RandomArray[mnIndex] = RndNumber;
            }
            return RandomArray;
        }
        catch (e) {
        }
    }
    ConstructSectionOjects(SectionInfo) {
        try {
            for (var i = 0; i < SectionInfo.length; i++) {
                if (i == 0) {
                    SectionInfo[i].spNo = i;
                    SectionInfo[i].epNo = SectionInfo[i].QuestionCount;
                    this.totalQuestionCount += SectionInfo[i].QuestionCount
                    continue;
                }
                if (SectionInfo[i + 1] != null && SectionInfo[i].SectionOrder < SectionInfo[i + 1].SectionOrder) {
                    SectionInfo[i].spNo = SectionInfo[i - 1].epNo + 1;
                    SectionInfo[i].epNo = SectionInfo[i - 1].epNo + SectionInfo[i].QuestionCount;
                    this.totalQuestionCount += SectionInfo[i].QuestionCount
                }
                else {
                    SectionInfo[i].spNo = SectionInfo[i - 1].epNo + 1;
                    SectionInfo[i].epNo = SectionInfo[i - 1].epNo + SectionInfo[i].QuestionCount;
                    this.totalQuestionCount += SectionInfo[i].QuestionCount
                }

            }
            return SectionInfo;

        }
        catch (ex) { }
    }
    CustomScrollBarIntialize(element, item, val) {
        try {
            if (window.screen.width == 1280 && window.screen.height == 1024 && this.Is_touch_device() == 0) {
                element.style.minHeight = window.screen.height - 300 + 'px';
                element.style.maxHeight = window.screen.height - 300 + 'px';
                element.style.height = window.screen.height - 300 + 'px';
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo) != 'undefined' && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'H' && val != '1')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo) != 'undefined' && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) == 'undefined' && val != '0')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && val == '1' && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) == 'undefined')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo) != 'undefined' && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'V' && val == '1')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo) != 'undefined' && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'V' && val == '0') {
                    this.IntializeScroll(element);
                    element.style.minHeight = window.screen.height - 600 + 'px';
                    element.style.maxHeight = window.screen.height - 600 + 'px';
                    element.style.height = window.screen.height - 600 + 'px';
                }

            }
            else if (window.screen.width == 1024 && window.screen.height == 768 && this.Is_touch_device() == 0) {
                element.style.minHeight = window.screen.height - 220 + 'px';
                element.style.maxHeight = window.screen.height - 220 + 'px';
                element.style.height = window.screen.height - 300 + 'px';
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'H' && val != '1')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) == 'undefined' && val != '0')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && val == '1' && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) == 'undefined')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'V' && val == '1')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'V' && val == '0') {
                    this.IntializeScroll(element);
                    element.style.minHeight = window.screen.height - 600 + 'px';
                    element.style.maxHeight = window.screen.height - 600 + 'px';
                    element.style.height = window.screen.height - 600 + 'px';
                }

            }
            else if (window.screen.width == 1152 && window.screen.height == 864 && this.Is_touch_device() == 0) {
                element.style.minHeight = window.screen.height - 220 + 'px';
                element.style.maxHeight = window.screen.height - 220 + 'px';
                element.style.height = window.screen.height - 300 + 'px';
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'H' && val != '1')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) == 'undefined' && val != '0')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && val == '1' && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) == 'undefined')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'V' && val == '1')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'V' && val == '0') {
                    this.IntializeScroll(element);
                    element.style.minHeight = window.screen.height - 600 + 'px';
                    element.style.maxHeight = window.screen.height - 600 + 'px';
                    element.style.height = window.screen.height - 600 + 'px';
                }

            }
            else if (this.Is_touch_device() == 0) {
                element.style.minHeight = window.screen.height - 320 + 'px';
                element.style.maxHeight = window.screen.height - 320 + 'px';
                element.style.height = window.screen.height - 300 + 'px';
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'H' && val != '1')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) == 'undefined' && val != '0')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && val == '1' && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) == 'undefined')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'V' && val == '1')
                    this.IntializeScroll(element);
                if (item.QuestionAttributes != "" && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'V' && val == '0') {
                    this.IntializeScroll(element);
                    element.style.minHeight = window.screen.height - 600 + 'px';
                    element.style.maxHeight = window.screen.height - 600 + 'px';
                    element.style.height = window.screen.height - 600 + 'px';
                }
                else
                    this.IntializeScroll(element);

            }
        }
        catch (ex) { }

    }
    IntializeScroll(element) {
        $(element).css("overflow", "scroll");
        //RB_UIMgnt.InitalizeCutomScroll(element);        
    }
    Is_touch_device() {
        //if (navigator.userAgent.indexOf("Firefox") > 0 || navigator.userAgent.indexOf("IE") > 0 || navigator.userAgent.indexOf("Safari") > 0)
        var isMobile = {
            Android: function () {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function () {
                return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
            }

        };

        if (isMobile.any() == null || isMobile.any() == undefined)
            return 0;
        else
            return 1;
    }
    AddClass(item, val, index) {
        var className = '';
        switch (val) {
            case 1:
                if (item.PInfo != null && item.PInfo.PassageXml != null && item.PInfo.PassageXml.length > 0 && typeof (item.QuestionAttributes.QuestionInfo) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'H')
                    className = 'ParatblLayOutH';
                else if (item.PInfo != null && item.PInfo.PassageXml != null && item.PInfo.PassageXml.length > 0 && typeof (item.QuestionAttributes.QuestionInfo) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment == 'V')
                    className = 'ParatblLayOut';
                else if (item.PInfo != null && item.PInfo.PassageXml != null && item.PInfo.PassageXml.length > 0)
                    className = 'ParatblLayOut';
                else if (item.QuestionPreferences != '' && item.QuestionPreferences != null)
                    className = 'ParatblLayOut';
                break;
            case 2:
                if (item.PInfo != null && item.PInfo.PassageXml != null && item.PInfo.PassageXml.length > 0 && typeof (item.QuestionAttributes.QuestionInfo) != 'undefined' && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment.toUpperCase() == 'H')
                    className = 'clsContentH';
                else if (item.PInfo != null && item.PInfo.PassageXml != null && item.PInfo.PassageXml.length > 0 && typeof (item.QuestionAttributes.QuestionInfo) != 'undefined' && typeof (item.QuestionAttributes.QuestionInfo.Passagealignment) != 'undefined' && item.QuestionAttributes.QuestionInfo.Passagealignment.toUpperCase() == 'V')
                    className = 'clsContentV';
                break;
            case 3:
                if (index == 0) className = "active";
                break;

        }
        return className;
    }
    FunctionCallMultiSource(item: any, selecteditem: any) {
        try {
            for (var i = 0; i < item.MultisourceOptions.ReferenceList.length; i++) {
                if (selecteditem == item.MultisourceOptions.ReferenceList[i].Title) {
                    item.selecteditem = item.MultisourceOptions.ReferenceList[i];
                    item.selecteditemText = item.selecteditem.Title;
                }
            }
        }
        catch (e) { }
    }
    FormatMultisource = function (item) {
        try {
            if (item.QuestionPreferences != null && typeof (item.QuestionPreferences) != 'undefined' && item.QuestionPreferences.length > 0) {
                item.MultisourceOptions = JSON.parse(item.QuestionPreferences);
                item.selecteditem = item.MultisourceOptions.ReferenceList[0];
                item.selecteditemText = item.selecteditem.Title;
                return item.MultisourceOptions;
            }
        }
        catch (e) { }
    }
    Getchecked(type: any, item: any, choice: any, userresponse, options: any) {
        try {
            switch (type) {
                case 'mcq':
				case'multiple choice static':
                    if (item.UserRepsonse != null && item.UserRepsonse.length > 0 && choice.Ident == item.UserRepsonse[0].split(':')[1] && choice.ID == item.UserRepsonse[0].split(':')[0])
                        return true;
                case 'sjt':
				case 'situational judgement type':
                    if (item.UserRepsonse != null && item.UserRepsonse.length > 0) {
                        for (var i = 0; i < item.UserRepsonse.length; i++) {
                            if (options.ID + ":" + options.Ident == item.UserRepsonse[i])
                                return true;
                        }

                    }
                    break;
                case 'mrs':
                    if (item.UserRepsonse != null && item.UserRepsonse.length > 0) {
                        for (var i = 0; i < item.UserRepsonse.length; i++) {
                            if (choice.Ident == item.UserRepsonse[i])
                                return true;
                        }

                    }

            }
        }
        catch (e) { }
    }
    AssignUserResponseFib(type, choice: any, item: any, userresponse, option): any {
        try {
            switch (type) {
                case 1:
                    if (userresponse != null && userresponse != undefined && userresponse.length > 0) {
                        for (var i = 0; i < userresponse.length; i++) {
                            if (choice.Ident == userresponse[i].split(':')[1]) {
                                for (var ch = 0; ch < item.Choices.length; ch++) {
                                    if (userresponse[i].split(':')[0] == item.Choices[ch].ID) {
                                        choice.userres = item.Choices[ch];
                                        choice.userres.ID = userresponse[i].split(':')[0];
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    break;
                case 2:
                    if (userresponse != null && userresponse != undefined && userresponse.length > 0) {
                        for (var i = 0; i < userresponse.length; i++) {
                            if (choice.ID == userresponse[i].split(':')[0] && option.Ident == userresponse[i].split(':')[1]) {
                                return true;
                            }
                        }
                    }
                    break;
                case 3:
                    var userAns = '';
                    if (userresponse != undefined && userresponse != null && userresponse.length > 0) {
                        userAns = userresponse[0];
                    }
                    return userAns;
                case 4:
                    if (userresponse != undefined && userresponse != null && userresponse.length > 0)
                        for (var i = 0; i < userresponse.length; i++) {
                            if (choice.ID == userresponse[i].split(':')[0])
                                return userresponse[i].split(':')[1];
                        }
                    break;
                case 5:
                    if (userresponse != null)
                        return userresponse;
                    break;
            }

        }
        catch (e) { }
    }
    AssignUserResponseGroupingTable(type, cell: any, item: any, userresponse, option) {
        try {

            if (userresponse != null && userresponse != undefined && userresponse.length > 0) {
                cell.userres = [];
                for (var i = 0; i < userresponse.length; i++) {
                    if (cell.id == userresponse[i].split(':')[0] && item.options != null && item.options.length > 0) {

                        for (var j = 0; j < item.options.length; j++) {
                            if (userresponse[i].split(':')[1] == item.options[j].id) {
                                let userResponse: any;
                                userResponse = item.options[j];
                                userResponse.cellid = userresponse[i].split(':')[0];
                                item.options[j].userres = userResponse.cellid;
                                cell.userres.push(userResponse);
                            }
                        }
                    }
                }
            }

        }
        catch (e) { }
    }
    AssignUserResponseMatchingDragAndDrop(type, item: any, userresponse, choice) {
        try {

            if (userresponse != null && userresponse != undefined && userresponse.length > 0) {

                for (var i = 0; i < userresponse.length; i++) {
                    for (var k = 0; k < item.Choices.length; k++) {
                        if (item.Choices[k].ID == userresponse[i].split(':')[0] && item.options != null && item.options.length > 0) {
                            for (var j = 0; j < item.options.length; j++) {
                                if (userresponse[i].split(':')[1] == item.options[j].Ident) {
                                    let userResponse: any;
                                    userResponse = item.options[j];
                                    userResponse.ID = userresponse[i].split(':')[0];
                                    item.options[j].userres = {}
                                    item.options[j].userres = userResponse.ID;
                                    item.Choices[k].userres = {};
                                    item.Choices[k].userres = userResponse;
                                    break;
                                }
                            }
                        }
                    }

                }
            }

        }
        catch (e) { }
    }
    ConstructPassageXML(item) {
        try {
            if (typeof (item.PInfo) != 'undefined' && item.PInfo.PassageXml.length > 0)
                return item.PInfo.PassageXml = item.PInfo.PassageXml.replace('<![CDATA[', '').replace(']]>', '');
        }
        catch (e) { }
    }
    constructPassageTabs(item) {
        try {
            if (item.PInfo != null && item.PInfo.PassageXmlContent != null && typeof (item.PInfo.Passagealignment) != 'undefined' && item.PInfo.Passagealignment != "" && item.PInfo.PassageXmlContent != null && item.PInfo.PassageXmlContent.indexOf("<tabs>") != -1) {
                var PassageTabs = item.PInfo.PassageXmlContent.substring(item.PInfo.PassageXmlContent.indexOf("<tabs>"), item.PInfo.PassageXmlContent.indexOf("</tabs>") + 7);
                var PassageTabsCntrl = $("tab", $(PassageTabs));
                var PassageTabsHeadning, PassageTabsContent;
                var PassageHeading = [];
                var PassageContent = [];
                for (var i = 0; i < PassageTabsCntrl.length; i++) {
                    PassageTabsHeadning = $("tabheading", PassageTabsCntrl[i]);
                    PassageTabsContent = $("tabcontent", PassageTabsCntrl[i]);
                    PassageHeading.push(PassageTabsHeadning[0].innerHTML);
                    PassageContent.push(PassageTabsContent[0].innerHTML);

                }
                item.PassageTabs = {
                    PassageHeading: PassageHeading,
                    PassageContent: PassageContent
                }
            }
        }
        catch (e) { }
    }
    CheckQuestionAttributes(item) {
        try {
            if (item.QuestionAttributes != "" && item.QuestionAttributes != null && item.QuestionAttributes.length > 0) {
                item.selectedItemCardinality = JSON.parse(item.QuestionAttributes);
                if (typeof (item.selectedItemCardinality.QuestionInfo) != 'undefined') {
                    item.selectedItemCardinality = item.selectedItemCardinality.QuestionInfo;
                }

            }
            else {
                if (typeof (item.QuestionAttributes) == 'object')
                    item.selectedItemCardinality = item.QuestionAttributes;
            }
        }
        catch (e) { }
    }
    HeadTabClick(event, item) {
        try {
            var target = event.target || event.srcElement || event.currentTarget;
            var currentTab = $(target).attr("id").substr(8, $(event.currentTarget).attr("id").length);
            var ptags = document.getElementsByName('pasgTab' + item.ID)
            var tabs = document.getElementsByName('pasgtabs' + item.ID)
            $.each(ptags, function (k, v) {
                if ($(v).attr("id").substr(7, $(v).attr("id").length) == currentTab) {
                    $(v).css("display", "block");
                    $(tabs[k]).addClass("active");
                }
                else {
                    $(v).css("display", "none");
                    $(tabs[k]).removeClass("active");
                }
            })
        }
        catch (e) { }
    }
    getMyStyles(index) {
        if (index == 0)
            return { 'display': 'block' };
        else if (index > 0)
            return { 'display': 'none' };

    }
    getwidthforColumn(columns) {
        return { 'width': (90 / columns.length) + '%' };

    }
    IntializeMoveArray(arraylst, from, to) {
        arraylst.splice(to, 0, arraylst.splice(from, 1)[0]);
        return this;
    }
    CallBackFunctionForTimeUpdate() {
        switch (Test.TestInfo.EnforceTimeAt) {
            case TimerAt.AssessmentLevel:
                (Test.TestInfo.TestTotalTime * 60) - StandardTimeFunctions.StartTime;
                break;
            case TimerAt.SectionLevel:
                if (Test.TestInfo.TimeRemaining == 0 && !this.isTimeOut) {
                    if (Test.TestInfo.AssessmentTypeCode == "SSET" || Test.TestInfo.AssessmentTypeCode == "HS" || Test.TestInfo.AssessmentTypeCode == "SELADAPTIVE") {
                        this.SectionTimeOutAction();
                        return false;
                    }
                    else {
                        if (Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionName.toLowerCase() == "analytical writing assessment")
                            this.SectionTimeOutAction();
                        else {
                            var sectionTotalTime = 0;
                            switch (Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionName) {
                                case "Analytical Writing Assessment":
                                    sectionTotalTime = 1800;
                                    break;
                                case "Quantitative":
                                    sectionTotalTime = 3720;
                                    break;
                                case "Verbal":
                                    sectionTotalTime = 3900;
                                    break;
                            }
                            if (sectionTotalTime != 0) {
                                Test.TestInfo.TimeRemaining = sectionTotalTime;
                                clearTimeout(_timerID);
                                StandardTimeFunctions.ResetTime(sectionTotalTime);
                                _timerID = setInterval("hlrTimeUpdate()", 1000);
                            }
                        }
                    }
                }
                break;
        }    
    }
    HandleControlsOnTimeOut() {
        try {
            if ($('#dvPauseArea').is(':visible')) this.HandlersOnPause(2);
            TestFunctions.ClosePopUp();
            this.CloseHelpdv();
        }
        catch (ex) { }
    }
	ShowAnswer() {
        try {
				var TestQuesList = $("div[type='Question']",  $("#divMainContent"))  as JQuery<HTMLElement>;								
				var el: HTMLElement = document.getElementById('divMainContent');
				el.parentNode;
				var ctParent: HTMLElement  = $("div[id='_" + this.QItems[this.mnpageNo - 1].ID + "']", el.parentNode)[0] ;

            switch (this.QItems[this.mnpageNo - 1].QType.toLocaleLowerCase()) {				
                case 'multiple choice static':                   
                    var htmlAdded = false;
                    var correctChoice = $("div[CID='" +this.QItems[this.mnpageNo - 1].CorrectOptions[0].Ident + "']", ctParent);
                    var maInputs = $("input[question='true']:radio", ctParent);					
					  var choiceArr = $("input[type='radio'][question='true']:checked", ctParent);					
					var S_Ident=this.QItems[this.mnpageNo - 1].CorrectOptions[0].Ident;    				
					var span = document.createElement('span');					
                    $.each(maInputs, function (index, ob) {   					
					var spnIcins = $("span", ob.parentElement);
					spnIcins.remove();
						$(ob).val() == S_Ident ? $(ob.parentElement).append($(span).addClass('statusright_l')) : "";							
                    });
                 
                    return;
                case "situational judgement type":
                        var maInputs = $("input[question='true']:radio", ctParent);	
						var len;
						$.each(maInputs, function (index, ob) {
					    $(ob).attr("disabled", 'true');		
							 $(ob).attr("style", "pointer-events: none;");								
							 $("span[class='statuswrong_SJT']").remove();
							  $("span[class='statusright_SJT']").remove();						
						});							
                    for (var i = 0;this.QItems[this.mnpageNo - 1].CorrectOptions != null && i <this.QItems[this.mnpageNo - 1].CorrectOptions.length; i++) {
                        var isTrue = false, htmlAdded = false, isRightAdded = false;						
                        try {										
                           if (this.QItems[this.mnpageNo - 1].UserRepsonse == null || typeof (this.QItems[this.mnpageNo - 1].UserRepsonse) == 'undefined' ||this.QItems[this.mnpageNo - 1].UserRepsonse.length == 0) {                         
                               $($('input[solutionid=' +this.QItems[this.mnpageNo - 1].CorrectOptions[i].ID +this.QItems[this.mnpageNo - 1].CorrectOptions[i].Ident + ']', ctParent)[0].parentElement).prepend('<span class="statusright_SJT"></div>');
								 isTrue = true; isRightAdded = true;
                                continue;
								}  															
								$($('input[solutionid=' +this.QItems[this.mnpageNo - 1].CorrectOptions[i].ID +this.QItems[this.mnpageNo - 1].CorrectOptions[i].Ident + ']', ctParent)[0].parentElement).prepend('<span class="statusright_SJT"></div>');
                                    isTrue = true; isRightAdded = true;														
                        }
                        catch (Ex) {
                            //$($('input[solutionid=' + value.split('$')[0] + value.split('$')[1] + ']', this.S_ctParent)[0].parentElement).prepend('<span class="statusright_l"></div>');
                            //isTrue = true;
                        }
                  
                    }
                    break;
                case "select a blank":
					$(".checkbox-inline", ctParent).empty()
                 // $($(".checkbox-inline", ctParent)[0].children).remove();
                    $($(".checkbox-inline", ctParent)[0]).append($.parseHTML(this.QItems[this.mnpageNo - 1].Text));                        
                    var maInputs = $("select[id='" + this.QItems[this.mnpageNo - 1].ID + "'][question='true']", ctParent);					
					var item=this.QItems[this.mnpageNo - 1];
					var itemid='"#'+this.QItems[this.mnpageNo - 1].ID+'"';
                    for (var chIndex = 0; chIndex < item.Choices.length; chIndex++) {					
                            if (item.UserRepsonse != null || typeof (item.UserRepsonse) != 'undefined' || item.UserRepsonse.length != 0) {								
									var indexN= chIndex+1;
									 var html = '<span class="lrn_clozedropdown_answer"><span style="padding-left:0%"><b>' + item.CorrectOptions[chIndex].Ident + '</b></span></span> '
									$("select[id='" + this.QItems[this.mnpageNo - 1].ID + "_" + indexN+ "'][question='true']", ctParent).each(function () {
									$('option', this).each(function () {										
									// console.log("$.trim($(this).text().toLowerCase())= " +$.trim($(this).text().toLowerCase()) +" chIndex "  +chIndex + "$.trim(item.CorrectOptions[chIndex].OptionsText.toLowerCase()) " +$.trim(item.CorrectOptions[chIndex].OptionsText.toLowerCase()));																		
										if ($.trim($(this).text().toLowerCase()) == $.trim(item.CorrectOptions[chIndex].OptionsText.toLowerCase())) {									
											$(this).attr('selected', 'selected');												
											//$("select[id='" + item.ID + "_" + indexN+ "'][question='true']", ctParent).attr('disabled', 'true');
											$("select[id='" + item.ID + "_" + indexN+ "'][question='true']", ctParent).addClass('lrn_clozedropdown_answer')											
											}										
										});
										});
                                continue;
                            }
							
                          }
                    break;

                default: break;
            }
        }
        catch (ex) { }
    }
CheckUserAnswer() {
        try {
				var TestQuesList = $("div[type='Question']",  $("#divMainContent"))  as JQuery<HTMLElement>;								
				var el: HTMLElement = document.getElementById('divMainContent');
				el.parentNode;
				var ctParent1: HTMLElement  = $("div[id='_" + this.QItems[this.mnpageNo - 1].ID + "']", el.parentNode)[0] ;				
				var count=0;
				
				switch (this.QItems[this.mnpageNo - 1].QType.toLocaleLowerCase()) 
				{
					case 'multiple choice static':                 
                    var htmlAdded = false;
                    var correctChoice = $("div[CID='" + this.QItems[this.mnpageNo - 1].CorrectOptions[0].Ident + "']", ctParent1);
                    var maInputs = $("input[question='true']:radio", ctParent1);					
                    var choiceArr = $("input[type='radio'][question='true']:checked",ctParent1);									
                    var span;					
                    if (this.QItems[this.mnpageNo - 1].UserRepsonse == null || typeof (this.QItems[this.mnpageNo - 1].UserRepsonse) == 'undefined' || this.QItems[this.mnpageNo - 1].UserRepsonse.length == 0) {
                        $(correctChoice[0]).addClass("correct");
                        $(correctChoice[0].childNodes[0]).addClass("correctButton");
                        return;
                    } else {							
                        span = document.createElement('span');	
						var spnIcins = $("span", choiceArr[0].parentElement);
						$("span",ctParent1).removeClass('statusright_l')
                        if ($(choiceArr).val() == this.QItems[this.mnpageNo - 1].CorrectOptions[0].Ident) {								
						spnIcins.remove();
                            $(choiceArr[0].parentElement).append('<span class="statusright_l"></div>');
                            htmlAdded = true;
                        }
                        else	{						
						spnIcins.remove();
                            $(choiceArr[0].parentElement).append('<span class="statuswrong_l"></div>');	}																
							
                    }      				
                    return;
					case "situational judgement type":
                    var maInputs = $("input[question='true']:radio", ctParent1);
					var item=this.QItems[this.mnpageNo - 1];
                    $.each(maInputs, function (index, ob) {
                        $(ob).attr("disabled", 'true');		
						 $("span[class='statuswrong_SJT']").remove();
							  $("span[class='statusright_SJT']").remove();							
                    })
					 var choiceArr = $("input[type='radio'][question='true']:checked",ctParent1);						
                    for (var i = 0; item.CorrectOptions != null && i < item.CorrectOptions.length; i++) {
                        var isTrue = false, htmlAdded = false, isRightAdded = false;						
                        try {									
                            if (item.UserRepsonse == null || typeof (item.UserRepsonse) == 'undefined' || item.UserRepsonse.length == 0) {						
                                $($('input[solutionid=' + item.CorrectOptions[i].id + item.CorrectOptions[i].Ident + ']', ctParent1)[0].parentElement).prepend('<span class="statusright_SJT"></div>');
                                continue;
                            }
                            $.each(item.UserRepsonse, function (index, value) {
                                $('input[solutionid=' + value.split(':')[0] + value.split(':')[1] + ']', ctParent1).attr("checked", "true");
                                if (item.CorrectOptions[i].ID == value.split(':')[0] && item.CorrectOptions[i].Ident == value.split(':')[1]) {							
                                    $($('input[solutionid=' + value.split(':')[0] + value.split(':')[1] + ']', ctParent1)[0].parentElement).prepend('<span class="statusright_SJT"></div>');
                                    isTrue = true; isRightAdded = true;
                                }
                            });
                        }
                        catch (Ex) {
                            //$($('input[solutionid=' + value.split('$')[0] + value.split('$')[1] + ']', ctParent1)[0].parentElement).prepend('<span class="statusright_l"></div>');
                            //isTrue = true;
                        }
                        try {
                            if (!isTrue) {
                                $.each(item.UserRepsonse, function (index, value) {
                                    if (value.split(':')[1] == item.CorrectOptions[i].Ident && htmlAdded == false && item.QuestionAttributes.Cardinality == "single") {
                                        if (!isRightAdded) {												
												$($('input[solutionid=' + value.split(':')[0] + value.split(':')[1] + ']', ctParent1)[0].parentElement).prepend('<span class="statuswrong_SJT"></div>');										}
										htmlAdded = true;
                                    }
                                    else if (value.split(':')[0] == item.CorrectOptions[i].ID && htmlAdded == false && item.QuestionAttributes.Cardinality == "multiple") {
                                        if (!isRightAdded) {										
                                            if (item.CorrectOptions[i].ID + ':' + item.CorrectOptions[i].Ident != value) $($('input[solutionid=' + value.split(':')[0] + value.split(':')[1] + ']', ctParent1)[0].parentElement).prepend('<span class="statuswrong_SJT"></div>');										}                                  
                                        htmlAdded = true;
                                    }
                                });
                            }
                            if (!isTrue && !htmlAdded) {
                                if (!isRightAdded && item.QuestionAttributes.Cardinality == "single") {
                                    for (var res = 0; res < item.UserRepsonse.length; res++) {
                                        if (item.UserRepsonse[res].split(':')[1] == item.CorrectOptions[i].Ident) {										
                                            $($('input[solutionid=' + item.UserRepsonse[res].split(':')[0] + item.CorrectOptions[i].Ident + ']', ctParent1)[0].parentElement).prepend('<span class="statuswrong_SJT"></div>');										
                                        }
                                    }
                                }
                                else if (!isRightAdded)								
                                    $($('input[solutionid=' + item.UserRepsonse[i].split(':')[0] + item.UserRepsonse[i].split(':')[1] + ']', ctParent1)[0].parentElement).prepend('<span class="statuswrong_SJT"></div>');				

									}

                        }
                        catch (ex) {
                        }

                    }
					
                    break;
					 case "select a blank":
					
                    //$($(".checkbox-inline", ctParent1)[0].children).remove();
                        $(".checkbox-inline", ctParent1).empty()
                   $($(".checkbox-inline", ctParent1)[0]).append($.parseHTML(this.QItems[this.mnpageNo - 1].Text));                        
                    var maInputs = $("select[id='" + this.QItems[this.mnpageNo - 1].ID + "'][question='true']", ctParent1);
					var item=this.QItems[this.mnpageNo - 1];
                    for (var chIndex = 0; chIndex < item.Choices.length; chIndex++) {                      
                            var isTrue = false;
							var indexN=chIndex+1;
                            if (item.UserRepsonse == null || typeof (item.UserRepsonse) == 'undefined' || item.UserRepsonse.length == 0) {
                                if ($("#" + item.CorrectOptions[chIndex].ID).length > 0) $("#" + item.CorrectOptions[chIndex].ID)[0].remove();
                               item.CorrectOptions[chIndex] = "";
                                continue;
                            }
                            try {
							$("select[id='" + this.QItems[this.mnpageNo - 1].ID + "_" + indexN+ "'][question='true']", ctParent1).each(function () {
									$('option', this).each(function () {
									if ($.trim($(this).text()) == $.trim(item.UserRepsonse[chIndex].split(':')[1])) {
											$(this).attr('selected', 'selected');
											//$("select[id='" + item.ID + "_" + indexN+ "'][question='true']", ctParent1).attr('disabled', 'true');
											if($.trim(item.UserRepsonse[chIndex].split(':')[1])==$.trim(item.CorrectOptions[chIndex].OptionsText))
												$("select[id='" + item.ID + "_" + indexN+ "'][question='true']", ctParent1).addClass('lrn_clozedropdown_answer')
											else	
											$("select[id='" + item.ID + "_" + indexN+ "'][question='true']", ctParent1).addClass('lrn_clozedropdown_answer wrong');																				
											};
									
										});
										});                            
                            }
                            catch (ex) {
                                isTrue = true;
                                if ($("#" + item.CorrectOptions[chIndex].ID).length > 0) $("#" + item.CorrectOptions[chIndex].ID)[0].remove();                             
                            }                          
                        
                    }

                    break;

                default: break;
            }
        }
        catch (ex) { }
    }
    SectionTimeOutAction() {
        try {
            this.HandleControlsOnTimeOut();
            this.TargetSectionId = this.GetTargetSectionId(); 
            if (!this.isTimeOut && this.GetTargetSectionId() == "" && Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionNumber == Test.Section.SectionInfo.children.length) {
                var ctParent = $("div[id='_" + Test.TestInfo.CurrentGUID + "']", Test.QuestionList.parentNode)[0];
                Navigation.TimeSpentOnQuestion(Test.TestInfo.CurrentPageNumber);
                Navigation.UpdateCurrentQuestionsResponses(ctParent, Test.TestInfo.CurrentGUID, false, Test.QuestionInfo[Test.TestInfo.CurrentGUID].QType);
                if (TestFunctions.hlrCheckForUserResponseUpdate != null)
                    TestFunctions.hlrCheckForUserResponseUpdate();
                var moData = TestFunctions.GetStoreStateValues(6);
                $("#dvopacityscreen").show();
                TestFunctions.ClosePopUp();
                TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 1);
                Test.Section.SectionInfo[Test.Section.ActiveSectionID].IsTimeout = true;
                Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeAvail = 0;
                Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeRemaining = 0;
                if (this.CheckAdativeSection(this.SectionInfo, Test.Section.ActiveSectionID)) {
                    moData.TestInfo.IsAdaptiveSectionsTimedOut = this.CheckBothAdaptiveSectionTimeoutOrOver();
                }

                this.SectionTimeOutConfirmOkAdaptive = () => {
                    try {
                        TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 1);
                        this.assessmentService.EvaluateQuestionUserResponse(moData, this.SectionInfo.Sections).subscribe(result => {
                            //storing question userresponse of  Last section of  end question.
                            this.assessmentService.StoreTestdata(moData).subscribe(result => {
                                TestFunctions.ClosePopUp();
                                $("#dvopacityscreen").hide();
                                if (Test.TestInfo.AssessmentTypeCode == "SSET" || Test.TestInfo.AssessmentTypeCode == "HS") {
                                    //this.UpdateResponse(Test.TestInfo.CurrentGUID, 1, $("#_" + Test.TestInfo.CurrentGUID)[0]);
                                    Navigation.StorePageResponse(Test.TestInfo.CurrentPageNumber);
                                    this.EndSecReview();
                                }
                                else {
                                    TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2);
                                    this.isTimeOut = true; this.isEndExam = true;
                                    this.ShowSectionInstructionOnEachCompleteSection();
                                    this.ActiveSectionId = Test.Section.ActiveSectionID;
                                }
                            })
                        });

                    }
                    catch (ex) { }
                };
                TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2);
                this.ShowMessage([Message.SELADAPTTIMEOUTLABEL, Message.SELADAPTTIMEOUT + "</b>"], this.SectionTimeOutConfirmOkAdaptive);
                return;
            }
            TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 1);
            this.isTimeOut = true;
            this.SectionTimeOutConfirmOk = () => {
                try {
                    TestFunctions.ClosePopUp();
                    clearInterval(this.timeoutTimer);
                    this.CallEvaluateInWindowClose(false);
					$("#dvopacityscreen").show();
                    if (Test.TestInfo.AssessmentTypeCode == "SSET" || Test.TestInfo.AssessmentTypeCode == "HS") {						
                        //this.UpdateResponse(Test.TestInfo.CurrentGUID, 1, $("#_" + Test.TestInfo.CurrentGUID)[0]);
                        Navigation.StorePageResponse(Test.TestInfo.CurrentPageNumber);
                        this.EndSecReview();
						$("#dvopacityscreen").hide();
                    }
                }
                catch (ex) { }
            };
			TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2);
            this.ShowMessage([Message.SELADAPTTIMEOUTLABEL, Message.SELADAPTTIMEOUT + "</b>"], this.SectionTimeOutConfirmOk);	
            $("#dvopacityscreen").show();
        }
        catch (e) { }
    }
    GetTargetSectionId(): string {
        try {
            var targetSectionid = '';
            for (var i = 0; i < this.SectionDetailsList.length; i++) {
                if ((Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionNumber + 1) == this.SectionDetailsList[i].SectionOrder)
                    targetSectionid = 'AMS_' + this.SectionDetailsList[i].SectionID;
            }
            return targetSectionid;
        }
        catch (e) { }
    }
    CheckPreviousSectionTimeout() {
        try {
            for (var i = 0; i < Test.Section.SectionInfo.children.length - 1; i++) {
                if (Test.Section.SectionInfo[Test.Section.SectionInfo.children[i]].TimeAvail == 0 && !this.isPreviuousSectionTimeOut)
                    this.isPreviuousSectionTimeOut = true;
            }
        }
        catch (e) { } 
    }
    CheckBothAdaptiveSectionTimeoutOrOver(): boolean {
        try {
            var timedOutAdaptiveSectionsCount = 0, completedAdaptSectionCount = 0,adaptiveSecCount=0;
            for (var i = 0; i < Test.Section.SectionInfo.children.length; i++) {
                //count of adaptive sections which has timed out
                if (Test.Section.SectionInfo[Test.Section.SectionInfo.children[i]].IsTimeout == true && Test.Section.SectionInfo[Test.Section.SectionInfo.children[i]].SectionTypeCode == 'SAAIS01') {
                    timedOutAdaptiveSectionsCount += 1;
                }
                // Count of the adaptive sections attended previously including current section
                if (Test.Section.SectionInfo[Test.Section.SectionInfo.children[i]].SectionNumber <= Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionNumber && Test.Section.SectionInfo[Test.Section.SectionInfo.children[i]].SectionTypeCode == 'SAAIS01')
                    completedAdaptSectionCount += 1;
				if(Test.Section.SectionInfo[Test.Section.SectionInfo.children[i]].SectionTypeCode == 'SAAIS01')
					adaptiveSecCount +=1;
            }
            if (timedOutAdaptiveSectionsCount == adaptiveSecCount || completedAdaptSectionCount == adaptiveSecCount)
                return true;
        }
        catch (e) { }
        return false;
    }
    ChangeSection(TargetSectionID, istimeOut = false): boolean {
        try {
            let sectionobj = this.CheckAdativeSection(this.SectionInfo, TargetSectionID);
            $("#dvopacityscreen").show();
            if (sectionobj) {
                var objSection = { SectionID: sectionobj.SectionID, SectionName: sectionobj.SectionName }
                this.assessmentService.GetAdaptiveSectionQuestion(Test.TestInfo.ScheduleDetailUserID, objSection).subscribe(result => {
                    var reponse: any = result;
					 var question = reponse.d;
                    if (reponse.d != null) {
                        $("#dvopacityscreen").hide();
                        TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2);
                        if (!this.isTimeOut) {
                            if (TargetSectionID != Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber))
                                this.ShowSectionInstructionOnEachCompleteSection();
                        }
                        else if (this.isTimeOut) {
                            if (TargetSectionID != Test.Section.ActiveSectionID)
                                this.ShowSectionInstructionOnEachCompleteSection();
                        }                       
                        this.AddPageNummber();
                        this.QItems.push(question);
                        this.isHtmlRendered = true; this.IsSectionChanged = true;
                        return true;
                    } else {
                       this.ReturnToHomeDashboard = () => {
                            try {
                                TestFunctions.ClosePopUp(null, null, true);
                                TestFunctions.ShowOrHideProgressMessage(Test.Msg2, 1);
                                var moData = TestFunctions.GetStoreStateValues(6);
                                this.assessmentService.ReturnParam(moData).subscribe(result => {
								 var parameters: any = result;
								if(parameters.d==null && Test.TestInfo.TestPrefController != null && Test.TestInfo.TestPrefController.RequestType == "525")
									location.href = location.protocol + "//" + window.location.host + '/' + myGlobals.appPath + '/Category/List.aspx';
								else{                                   
                                    parameters = parameters.d;
                                    location.href = parameters.Extension2 + "?" + parameters.Extension1;
									}
                                    return false;
                                });
                            }
                            catch (ex)
                            { }
                        };
                        this.ShowMessage(["ErrorCode- ES001", "The Practice Exam you are trying to take is unavailable at this time. Please try again later."], this.ReturnToHomeDashboard);
                       
                        //Summary.ShowMessage(["Navigation", "Sorry, Get Section Error"]);
                        Test.TestInfo.IsTestTerminated = true;
                        $("#dvopacityscreen").hide();
                        TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2);
                        return true;
                    }

                })
            }
            else {
                var currentSecId = "";
                this.IsSectionChanged = true;
                if (this.isTimeOut && !this.isPreviuousSectionTimeOut) {
                    Test.TestInfo.TargetSectionID = this.TargetSectionId;
                    this.pageNo += 1; this.endPageNo = Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo;
                    this.StoreTestDataAndSetDisplay(this.GetquestionObject());
                }
                else if (this.isTimeOut && this.isPreviuousSectionTimeOut) {
                    this.StoreTestDataAndSetDisplay(this.GetquestionObject());
                }
                else if (!this.isTimeOut && this.isPreviuousSectionTimeOut) {
                    this.StoreTestDataAndSetDisplay(this.GetquestionObject());
                }
                else {
                    currentSecId = Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber);
                    if (currentSecId != Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber + 1))
                        this.ShowSectionInstructionOnEachCompleteSection();
                    this.CallClickEvents();
                    Navigation.ChangeTargetSection();
                }
                TestFunctions.ClosePopUp();
                TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2);
                this.pageNo = 1;
                this.endPageNo = Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo;
				 try {
                    //Since section is getting changed, this is called to update the current GUID and current section
                    //Storing these values is helpful when the session gets timeout, just after section changes
                    if (Test.Section.ActiveSectionID != '' && Test.TestInfo.CurrentGUID != '') {
                        this.assessmentService.UpdateCurrentDetails(Test.Section.ActiveSectionID, Test.TestInfo.CurrentGUID).subscribe(result => {
                            var reponseData: any;
                            reponseData = result;
                            if (reponseData == null || reponseData.length == 0 || reponseData.d == "") {
                            }
                        });
                    }
                }
                catch (ex)
                { }
                if ($(".quesNo") != null) $(".quesNo").html(this.pageNo + "&nbsp;of&nbsp;" + Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions);
                if (this.totalQuestionCount == Test.TestInfo.CurrentPageNumber)
                    $("#btnNext").css('visibility', 'visible');
                else
                    $("#btnNext").css('visibility', 'visible');
                return true;
            }
        } 
        catch (e) { }

    }
    AddPageNummber() {
        Test.TestInfo.NumberOfQuestions += 1;
        Test.TestInfo.NumberOfPages += 1;
    }
    UpdateResponse(itemId, type, questionDiv) {
        try {
            var ctParent = $("div[id='_" + Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1] + "']", Test.QuestionList.parentNode)[0];
            Navigation.TimeSpentOnQuestion(Test.TestInfo.CurrentPageNumber);
            Navigation.UpdateCurrentQuestionsResponses(ctParent, Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1], false, Test.QuestionInfo[Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1]].QType);
            if (TestFunctions.hlrCheckForUserResponseUpdate != null)
                TestFunctions.hlrCheckForUserResponseUpdate();
            var moData = TestFunctions.GetStoreStateValues(6);
            this.assessmentService.StoreTestdata(moData).subscribe(result => {
                var reponse: any = result;
                var question = reponse.d;

                if ((Test.TestInfo.AssessmentTypeCode != "SSET" || Test.TestInfo.AssessmentTypeCode != "HS") && this.isTimeOut && !this.isPreviuousSectionTimeOut && (Test.Section.SectionInfo[this.TargetSectionId].SectionName.toLocaleLowerCase().indexOf('integrated reasoning') != -1 || Test.Section.SectionInfo[this.TargetSectionId].SectionName.toLocaleLowerCase().indexOf('analytical writing assessment') != -1)) {
                    Test.Section.TargetSectionID = this.TargetSectionId;
                    TestFunctions.ChangeTargetSection();
                    this.endPageNo = Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo;
                    this.pageNo += 1;
                    if ($(".quesNo") != null) $(".quesNo").html(this.pageNo + "&nbsp;of&nbsp;" + Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions);
                }
                this.isTimeOut = false;
                switch (type) {
                    case 1:
                        Test.Section.ActiveSectionID = 'AMS_' + $(questionDiv).attr("secid");
                        Test.TestInfo.FPNo = Test.TestInfo.CurrentPageNumber;
                        Test.TestInfo.TPNo = Test.TestInfo.CurrentPageNumber + 1;
                        Test.TestInfo.PreviousPageNumber = Test.TestInfo.FPNo;
                        Navigation.SetDisplay(Test.TestInfo.PreviousPageNumber, false);
                        Navigation.SetDisplay(Test.TestInfo.TPNo, true);
                        Test.TestInfo.CurrentPageNumber = Test.TestInfo.TPNo;
                        this.pageNo = Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestionsAttempted + 1;
                        if ($(".quesNo") != null) $(".quesNo").html(this.pageNo + "&nbsp;of&nbsp;" + Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions);
                        break;
                    case 2:
                        Test.TestInfo.CurrentGUID = itemId;
                        Test.Section.ActiveSectionID = this.TargetSectionId;
                        this.isPreviuousSectionTimeOut = true;
                        Test.TestInfo.FPNo = Test.TestInfo.CurrentPageNumber;
                        Test.TestInfo.TPNo = Test.TestInfo.CurrentPageNumber + 1;
                        Test.Section.ActiveSectionID = 'AMS_' + $(questionDiv).attr("secid");
                        Test.TestInfo.PreviousPageNumber = Test.TestInfo.FPNo;
                        Navigation.SetDisplay(Test.TestInfo.PreviousPageNumber, false);
                        Navigation.SetDisplay(Test.TestInfo.TPNo, true);
                        Test.TestInfo.CurrentPageNumber = Test.TestInfo.TPNo;
                        this.pageNo = Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestionsAttempted + 1;
                        if ($(".quesNo") != null) $(".quesNo").html(this.pageNo + "&nbsp;of&nbsp;" + Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions);
                        break;
                }
				this.HandleBookmarkedStatus();
            })
        }
        catch (e) { }
    }
    GetquestionObject(): any {
        var ctParent = $("div[id='_" + Test.TestInfo.CurrentGUID + "']", Test.QuestionList.parentNode)[0];
        if (typeof (Test.QuestionInfo[Test.TestInfo.CurrentGUID].QType) != 'undefined' && Test.QuestionInfo[Test.TestInfo.CurrentGUID] != null) {
            Navigation.TimeSpentOnQuestion(Test.TestInfo.CurrentPageNumber);
            Navigation.UpdateCurrentQuestionsResponses(ctParent, Test.TestInfo.CurrentGUID, false, Test.QuestionInfo[Test.TestInfo.CurrentGUID].QType);
            if (TestFunctions.hlrCheckForUserResponseUpdate != null)
                TestFunctions.hlrCheckForUserResponseUpdate();
            var moData = TestFunctions.GetStoreStateValues(6);
            return moData;
        }
    }

    StoreTestDataAndSetDisplay(moData) {
        try {
            this.assessmentService.StoreTestdata(moData).subscribe(result => {
                if (this.isPreviuousSectionTimeOut && Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestionsAttempted == Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions) {
                    this.ShowSectionInstructionOnEachCompleteSection();
                    this.randomsections = true;
                }
                else if (this.isPreviuousSectionTimeOut && Test.Section.SectionInfo[Test.Section.ActiveSectionID].IsTimeout && Test.Section.ActiveSectionID != this.TargetSectionId) {
                    this.ShowSectionInstructionOnEachCompleteSection();
                    this.randomsections = true;
                }
                else if (!this.isPreviuousSectionTimeOut && Test.Section.SectionInfo[Test.Section.ActiveSectionID].IsTimeout && Test.Section.ActiveSectionID != this.TargetSectionId) {
                    this.ShowSectionInstructionOnEachCompleteSection();
                    this.randomsections = true;
                }
                else this.SetDisplay();
            });
        } catch (e) { }
    }
    SetDisplay(istimeout = false) {
        try {
            if (!this.isPreviuousSectionTimeOut) this.CheckPreviousSectionTimeout();
            Test.TestInfo.FPNo = Test.TestInfo.CurrentPageNumber;
            Test.TestInfo.TPNo = Test.TestInfo.CurrentPageNumber + 1;
            if (istimeout){
                if (this.TargetSectionId != '') Test.Section.ActiveSectionID = this.TargetSectionId;
                this.IsSectionChanged = true;
                this.pageNo = 1;
                this.endPageNo = Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo;
            }
            Test.TestInfo.PreviousPageNumber = Test.TestInfo.FPNo;
            if (Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionName.indexOf('Analytical Writing Assessment') != -1) {
                var msguid = $("div[type='question'][questiontype='Essay']", Test.QuestionList.parentNode)[0].getAttribute("id");
                msguid = msguid.replace('_', '');
                Test.TestInfo.CurrentGUID = msguid;
                Navigation.SetDisplay(Test.TestInfo.PreviousPageNumber, false);
                Test.Section.ActiveSectionID = 'AMS_' + $("div[type='question'][questiontype='Essay']", Test.QuestionList.parentNode)[0].getAttribute("secid");
                var editorID;
                if (Test.QuestionInfo[Test.TestInfo.CurrentGUID].EditorID == null) {
                    CKEDITOR.appendTo("EssayTextCKE" + Test.TestInfo.CurrentGUID, null, "");
                    for (var eachobj in CKEDITOR.instances) { editorID = eachobj; }
                    Test.QuestionInfo[Test.TestInfo.CurrentGUID].EditorID = editorID;
                }
				Test.TestInfo.CurrentPageQSNo = TestFunctions.GetFirstQuestionNoOfPage(Test.TestInfo.TPNo, true);
                Test.TestInfo.CurrentPageQENo = TestFunctions.GetLastQuestionNoOfPage(Test.TestInfo.TPNo, true);
               
                $("div[type='question'][questiontype='Essay']", Test.QuestionList.parentNode)[0].style.display = "block";
            }
            else {
				Test.TestInfo.CurrentGUID = Test.QuestionInfo.children[Test.TestInfo.TPNo - 1];
                Navigation.SetDisplay(Test.TestInfo.PreviousPageNumber, false);
                Navigation.SetDisplay(Test.TestInfo.TPNo, true);
                //Test.TestInfo.CurrentGUID = Test.QuestionInfo.children[Test.TestInfo.TPNo - 1];
            }
            Test.TestInfo.CurrentPageNumber = Test.TestInfo.TPNo;
            Test.TestInfo.PreviousGUID = Test.QuestionInfo.children[Test.TestInfo.FPNo - 1];
            if (this.TargetSectionId != "") {
                this.isTimeOut = false;
            }
            $("#lblCurrentSecName").html(Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionName);
            TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2);
            $("#dvopacityscreen").hide();
            this.IsSectionChanged == false ? this.pageNo++ : this.IsSectionChanged = false;
            if ($(".quesNo") != null) $(".quesNo").html(this.pageNo + "&nbsp;of&nbsp;" + Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions);
            switch (this.Preferences.StylesheetName.toLocaleLowerCase()) {
                case "deepblue":
                    if (this.totalQuestionCount == Test.TestInfo.CurrentPageNumber)
                        $("#btnNext").css('visibility', 'visible');
                    else
                        $("#btnNext").css('visibility', 'visible');
                    this.HandleBookmarkedStatus();
                    break;
            }
        }
        catch (e) { }
    }
    CallEvaluateInWindowClose(isClosed) {
        try {
            var ctParent = $("div[id='_" + Test.TestInfo.CurrentGUID + "']", Test.QuestionList.parentNode)[0];
			 //hlrUpdateTimeAvail();
            Navigation.TimeSpentOnQuestion(Test.TestInfo.CurrentPageNumber);
            Navigation.UpdateCurrentQuestionsResponses(ctParent, Test.TestInfo.CurrentGUID, false, Test.QuestionInfo[Test.TestInfo.CurrentGUID].QType);
            if (TestFunctions.hlrCheckForUserResponseUpdate != null)
                TestFunctions.hlrCheckForUserResponseUpdate();
            if (isClosed && !$("#dvTestContent").is(":visible")) {
                if (Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestionsAttempted == 0 && Test.TestInfo.TimeRemaining < 0)
                    Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeRemaining = Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionTotalTime;
            }
            Test.TestInfo.IsClosed = isClosed;
            var moData = TestFunctions.GetStoreStateValues(6);
            moData.TestInfo.IsClosed = isClosed;
            if (isClosed && !$("#dvTestContent").is(":visible")) {
                if (Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestionsAttempted == 0 && Test.TestInfo.TimeRemaining < 0)
                    Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeRemaining = Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionTotalTime;
                if (Test.TestInfo.EnforceTimeAt == TimerAt.SectionLevel)
                    moData.TestInfo.TimeRemaining = "-1";
            }
            $("#dvopacityscreen").show();
            TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 1);
            if (this.isTimeOut) Test.Section.SectionInfo[Test.Section.ActiveSectionID].IsTimeout = true;
            if (!isClosed && this.CheckAdativeSection(this.SectionInfo, Test.Section.ActiveSectionID)) {
                moData.TestInfo.IsAdaptiveSectionsTimedOut = this.CheckBothAdaptiveSectionTimeoutOrOver();
            }
            if (isClosed && !$("#dvTestContent").is(":visible")) { }
            else  if (!isClosed) {
                if (this.isTimeOut) {
                    Test.Section.SectionInfo[Test.Section.ActiveSectionID].IsTimeout = true;
                    Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeAvail = 0;
                    Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeRemaining = 0;
                    moData.TestInfo.IsAdaptiveSectionsTimedOut = this.CheckBothAdaptiveSectionTimeoutOrOver();
                }
                this.assessmentService.EvaluateQuestionUserResponse(moData, this.SectionInfo.Sections).subscribe(result => {
                    if (this.isTimeOut) {
                        this.TargetSectionId = this.GetTargetSectionId();
                        if (this.TargetSectionId != '' && typeof (this.TargetSectionId) != 'undefined') {
                            this.ActiveSectionId = Test.Section.ActiveSectionID;
                            TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 1);
                            Test.Section.SectionInfo[Test.Section.ActiveSectionID].IsTimeout = true;
                            Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeAvail = 0;
                            Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeRemaining = 0;
                            this.ChangeSection(this.TargetSectionId, true);
                        }
                    }
                });
            }
            // When we are in the sectioninstructions page after completing any section, if the next section is non- adaptive, then this block will assign the next section details to active section attributes
            //But if next section is adaptive, already next sections details will be there in active section attributes
            if (isClosed) this.UpdateCurrentSectionDetailsOnClose(moData);			
        } catch (e) { }
    }
    UpdateCurrentSectionDetailsOnClose(moData) {
        try {
            if (!$("#dvTestContent").is(":visible") && Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestionsAttempted == 0 && Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeSpent == 0
                && this.CheckAdativeSection(this.SectionInfo, Test.Section.ActiveSectionID)) {
                // While closing the window, if the it is end instruction or start instruction page and the next section is adaptive(its first question is already bound), save the leadingIBN, correctIBN and incorrectIBN values got for the first question
                this.assessmentService.EvaluateQuestionUserResponse(moData, this.SectionInfo.Sections).subscribe(result => {
                });
                return;
            }
            if (!$("#dvTestContent").is(":visible") &&
                ((this.isTimeOut && Test.Section.SectionInfo[Test.Section.ActiveSectionID].IsTimeout) ||
                    Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestionsAttempted ==
                    Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions)) {

                let TargetSectionID = this.GetTargetSectionId();
                if (!this.CheckAdativeSection(this.SectionInfo, TargetSectionID)) {
                    if (TargetSectionID != '') Test.Section.ActiveSectionID = TargetSectionID;
                    Test.Section.ActiveSectionNumber = Test.Section.SectionInfo[TargetSectionID].SectionNumber;
                    //Test.TestInfo.CurrentGUID = Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber];
                    for (var m = Test.TestInfo.CurrentPageNumber; m < Test.QuestionInfo.children.length; m++) {
                        if (Test.Section.ActiveSectionID == "AMS_" + Test.QuestionInfo[Test.QuestionInfo.children[m]].SectionID) {
                            Test.TestInfo.CurrentGUID = Test.QuestionInfo.children[m]; break;
                        }
                    }
                    if (!$("#dvTestContent").is(":visible")) {
                        if (Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestionsAttempted == 0 && Test.TestInfo.TimeRemaining < 0)
                            Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeRemaining = Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionTotalTime;
                    }
                }
            }		
			 
        }
        catch (ex) { }
    }
    FunctionCall_footer(arg1, arg2, arg3) {
        switch (arg3) {
            case 4:
                var target = arg2.target || arg2.srcElement || arg2.currentTarget;
                FunctionCall(arg1, target);
                break;
            case 3:
                var target = arg2.target || arg2.srcElement || arg2.currentTarget;
                FunctionCall(arg1, target);
                break;
        }
    }
    FunctionCall(arg1, arg2, arg3) {
        try {
            if (arg1 == 4) this.isNextClicked = true;
            if (arg1 == 3) this.isPrevClicked = true;
            this.arg1 = arg1, this.arg2 = arg2, this.arg3 = arg3;
            var questionDiv, qtype;
            let TargetSectionID = Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber + 1);
            this.callConfirm = () => {
                if (Test.TestInfo.TimeRemaining < 5) {
                    TestFunctions.ClosePopUp();
                    TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 1);
                    $("#dvopacityscreen").show();
                    return false;
                }
                TestFunctions.ClosePopUp();
                //this.TimeToRestartAfterPause = StandardTimeFunctions.GetTimeInSeconds(ctTimer.value, 1);
                clearTimeout(_timerID);
                IsNextQuesTimer = true;            
                var ctParent = $("div[id='_" + Test.TestInfo.CurrentGUID + "']", Test.QuestionList.parentNode)[0];
                Navigation.TimeSpentOnQuestion(Test.TestInfo.CurrentPageNumber);
                Navigation.UpdateCurrentQuestionsResponses(ctParent, Test.TestInfo.CurrentGUID, false, Test.QuestionInfo[Test.TestInfo.CurrentGUID].QType);
                if (TestFunctions.hlrCheckForUserResponseUpdate != null)
                    TestFunctions.hlrCheckForUserResponseUpdate();
                var moData = TestFunctions.GetStoreStateValues(6);
                TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 1);
                $("#dvopacityscreen").show();
                Test.TestInfo.EvaluateRequestStatus = 1;
                this.ReturnToHomeDashboard = () => {
                    try {
                        TestFunctions.ClosePopUp(null, null, true);
                        TestFunctions.ShowOrHideProgressMessage(Test.Msg2, 1);
                        var moData = TestFunctions.GetStoreStateValues(6);
                        this.assessmentService.ReturnParam(moData).subscribe(result => {
                            var parameters: any = result;
							if(parameters.d==null && Test.TestInfo.TestPrefController != null && Test.TestInfo.TestPrefController.RequestType == "525")
									location.href = location.protocol + "//" + window.location.host + '/' + myGlobals.appPath + '/Category/List.aspx';
							else{  
                            parameters = parameters.d;
                            location.href = parameters.Extension2 + "?" + parameters.Extension1;}
                            return false;
                        });
                    }
                    catch (ex)
                    { }
                };

                this.assessmentService.EvaluateQuestionUserResponse(moData, this.SectionInfo.Sections).subscribe(result => {
                    //if (this.isTimeOut) return;
                    Test.TestInfo.EvaluateRequestStatus = 0;
                    var reponse: any = result;
                    if (reponse != null && reponse.d != null) {
                        switch (reponse.d) {
                            case "SOUT":
                                var msMsg = Message.SESSIONTIMEOUT;
                                clearTimeout(_timerID);
                                Test.TestInfo.CurrentMethodName = StateFailed.Types.SessionExpired;
                                TestFunctions.hlrStoreStateFailure();
                                this.ShowMessage(["Session Timed Out", msMsg + "</b>"], ReturnToURL);
                                return;
                            case "POSTFAILURE":
                                clearTimeout(_timerID);
                                Test.TestInfo.CurrentMethodName = StateFailed.Types.SessionExpired;
                                TestFunctions.hlrStoreStateFailure();
                                //Summary.ShowMessage(["ErrorCode- ES003", "The Practice Exam you are trying to take is unavailable at this time. Please try again later." + "</b>"], "SessionTimeOut");
                                this.ShowMessage(["ErrorCode- ES003", "The Practice Exam you are trying to take is unavailable at this time. Please try again later." + "</b>"], this.ReturnToHomeDashboard);
                                return;
                            case "TOKENFAIL":
                                clearTimeout(_timerID);
                                Test.TestInfo.CurrentMethodName = StateFailed.Types.SessionExpired;
                                TestFunctions.hlrStoreStateFailure();
                                //Summary.ShowMessage(["ErrorCode- ES005", "The Practice Exam you are trying to take is unavailable at this time. Please try again later." + "</b>"], "SessionTimeOut");
                                this.ShowMessage(["ErrorCode- ES005", "The Practice Exam you are trying to take is unavailable at this time. Please try again later." + "</b>"], this.ReturnToHomeDashboard);
                                return;
                            case "SESSIONVALUEFAIL":
                                clearTimeout(_timerID);
                                Test.TestInfo.CurrentMethodName = StateFailed.Types.SessionExpired;
                                TestFunctions.hlrStoreStateFailure();
                                //Summary.ShowMessage(["ErrorCode-ES005", "The Practice Exam you are trying to take is unavailable at this time. Please try again later." + "</b>"], "SessionTimeOut");
                                this.ShowMessage(["ErrorCode-ES006", "The Practice Exam you are trying to take is unavailable at this time. Please try again later." + "</b>"], this.ReturnToHomeDashboard);
                                return;
                        }
                    }
                    if (reponse != null && reponse.d != null) {
                        var question = JSON.parse(reponse.d);
                        this.TargetSectionId = this.GetTargetSectionId();
                        if (question.QuestionsData == null && (typeof (TargetSectionID) == 'undefined' || TargetSectionID == undefined)) {
                            this.EndAdaptiveExam(); return;
                        }
                        else if (this.TargetSectionId == '' && Test.QuestionInfo[Test.TestInfo.CurrentGUID].QType == "Essay") {
                            this.EndAdaptiveExam(); return;
                        }
                        /*else if (this.TargetSectionId == '' && this.isPreviuousSectionTimeOut && Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionName.toLocaleLowerCase() == "verbal" && this.pageNo == Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions) {
                            this.EndAdaptiveExam(); return;
                        }*/
						else if (this.TargetSectionId == '' && this.isPreviuousSectionTimeOut && this.pageNo == Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions) {
                            this.EndAdaptiveExam(); return;
                        }
						else if(this.TargetSectionId == '' && this.isTimeOut){
						this.EndAdaptiveExam(); return;
						}
                        else if (this.isPreviuousSectionTimeOut) {
                            var questDiv = $("div[id='_" + Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1] + "']", Test.QuestionList.parentNode)[0];
                            var isAdaptive = this.CheckAdativeSection(this.SectionInfo, 'AMS_' + $(questDiv).attr("secid"));
                            if (questDiv != null && question.QuestionsData == null && !isAdaptive && this.pageNo == Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions) {
                                this.TargetSectionId = this.GetTargetSectionId();
                                if (this.CheckAdativeSection(this.SectionInfo, this.TargetSectionId) && 'AMS_' + $(questDiv).attr("secid") != this.TargetSectionId) {
                                    TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 1);
                                    if (this.ChangeSection(this.TargetSectionId)) return true;
                                    return;

                                } else {
                                    this.StoreTestDataAndSetDisplay(this.GetquestionObject());
                                    return;
                                }
                            }
                            else if (questDiv != null && question.QuestionsData == null && !isAdaptive) {
                                this.StoreTestDataAndSetDisplay(this.GetquestionObject());
                                return;
                            }
                            else if (question.QuestionsData == null && this.TargetSectionId != Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber)) {
                                TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 1);
                                if (this.ChangeSection(this.TargetSectionId)) return true;
                                return;
                            }
                        }
                        else if (question.QuestionsData == null && TargetSectionID != Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber)) {
                            TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 1);
                            if (this.ChangeSection(TargetSectionID)) return true;
                            return;
                        }
                        else if (question.QuestionsData == null && this.CheckAdativeSection(this.SectionInfo, Test.Section.GetSectionIDForSelAdaptive(Test.TestInfo.CurrentPageNumber + 1))) {
                            $("#dvopacityscreen").hide();
                            //Summary.ShowMessage(["Navigation", "Sorry, Fetching question from API is failed,Please contact administrator"]);
                            this.ShowMessage(["ErrorCode- ES002", "The Practice Exam you are trying to take is unavailable at this time. Please try again later."], this.ReturnToHomeDashboard);
                            TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2); Test.TestInfo.IsTestTerminated = true
                            return;
                        }
                        else if (question.QuestionsData == null) {
                            var TargetSecID = Test.Section.GetSectionIDForSelAdaptive(Test.TestInfo.CurrentPageNumber + 1);
                            if (TargetSecID != Test.Section.GetSectionIDForSelAdaptive(Test.TestInfo.CurrentPageNumber))
                                this.ShowSectionInstructionOnEachCompleteSection();
                            this.CallClickEvents();
                            $("#dvopacityscreen").hide(); Navigation.ChangeTargetSection();
                            this.endPageNo = Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo;
                            if ($(".quesNo") != null) $(".quesNo").html(this.pageNo + "&nbsp;of&nbsp;" + Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions);
                            if (this.totalQuestionCount == Test.TestInfo.CurrentPageNumber)
                                $("#btnNext").css('visibility', 'visible');
                            else
                                $("#btnNext").css('visibility', 'visible');
                            TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2); return; 
                        }

                        if (this.CheckAdativeSection(this.SectionInfo, Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber + 1)) && !Test.TestInfo.IsTestTerminated) {
                            this.AddPageNummber();
                        }
                        this.QItems.push(question.QuestionsData);
                        this.isHtmlRendered = true; $("#dvopacityscreen").hide();
                        TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2);
                    }
                });
            };
            this.EndAdaptiveExam = () => {
                if (Test.IsSubmitted || Test.TestInfo.IsSubmitClicked) return;
                var strIsStored = false;
                if (Test.TestInfo.IsTimeout && Test.TestInfo.EnforceTimeAt != 1)
                    strIsStored = true;
                else {
                    if (Test.ConfigPreferences.AuditTriallingEnabled) {
                        var Questiontype = Test.QuestionInfo[Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1]].QType;
                        if (Question.Types.MultipleChoiceStatic != Questiontype.toUpperCase() && Question.Types.MultipleChoiceDynamic != Questiontype.toUpperCase() && Question.Types.LinkertScale != Questiontype.toUpperCase() && Question.Types.TrueOrFalse != Questiontype.toUpperCase() && Question.Types.DiscreteOptionMultipleChoice != Questiontype.toUpperCase() && Question.Types.EMQ != Questiontype.toUpperCase()) {
                            ActionSequence.RegisterNewAction(1, 8, Test.TestInfo.CurrentPageNumber, ctTimer.value, 1);
                            ActionSequence.UpdateLastAction(ActionStatusType.True, TestFunctions.StoreResponseAuditTrial(), '', '', '');
                        }
                    }
                    strIsStored = Navigation.StorePageResponse(Test.TestInfo.CurrentPageNumber);
                }
                if (!strIsStored) return;
                var strIsAllAns = false;
                TestFunctions.CloseAllWidgets();
                TestFunctions.GetUserResponseOptions();
                if ((Test.TestInfo.TotalQuestionsAttended == Test.QuestionInfo.children.length) || (Test.TestInfo.TotalQuestionsAttended == Test.QuestionInfo.children.length - 1) || this.isPreviuousSectionTimeOut) {
                    $("#dvopacityscreen").hide();
                    TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2);
                    TestFunctions.ClosePopUp();
                    Navigation.ShowInstructionForSection(null);
                    this.EndExamMessages = 0;
                    this.isEndExam = true;
                    this.ShowSectionInstructionOnEachCompleteSection();
                    return;
                }
            }
            this.CallClickEvents = () => {
                switch (arg3) {
                    case 0:
                        if (this.TestInfo.AssessmentTypeCode == "SELADAPTIVE" || ((this.TestInfo.AssessmentTypeCode == "SSET" || this.TestInfo.AssessmentTypeCode == "HS") && Test.TestInfo.CurrentPageNumber != Test.QuestionList.length)) {
                            if (TargetSectionID == undefined || TargetSectionID == null || TargetSectionID == "") return;
                        }
                        if (this.TestInfo.AssessmentTypeCode == "SSET" || this.TestInfo.AssessmentTypeCode == "HS") {
                            if (this.isNextClicked && this.Review && Test.TestInfo.CurrentPageNumber == Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo) {                            								
                                this.ReviewScreen();
                                $("#dvopacityscreen").css("display", "none");
                                $("#dvTestContent").hide();
                                $("#lowerStrip").css("display", "none");
                                $("#spnSecRev").css("display", "none");
                                $("#dvSectioninstruction").css("display", "none");
                                this.Review=false;
                                this.isReviewMode = false;
                                RvwTime = false;
                                return true;
                            }
                            if (this.isReviewMode) {
                            if (arg1 == 4) { this.RPQuestIndex++; this.isNextClicked = false; }
                            if (arg1 == 3) { this.RPQuestIndex--; this.isPrevClicked = false; }
                            Navigation.StorePageResponse(Test.TestInfo.CurrentPageNumber);
                            Test.TestInfo.PreviousPageNumber = Test.TestInfo.CurrentPageNumber;
                            Test.TestInfo.CurrentPageNumber = this.Rvwqueslist[this.RPQuestIndex];
                            if (Test.TestInfo.CurrentPageNumber == undefined && Test.TestInfo.PreviousPageNumber == this.Rvwqueslist[this.Rvwqueslist.length - 1]) {
                                if(Test.TestInfo.CurrentPageNumber == undefined) Test.TestInfo.CurrentPageNumber = Test.TestInfo.PreviousPageNumber;
                                this.reviewEndScreen();
                                return;//$("#btnNext").css("display", "none");
                            }
                            Navigation.ShowPage();

                            if (Test.TestInfo.CurrentPageNumber == this.Rvwqueslist[this.startcount]) $("#btnPrev").css('visibility', 'hidden');
                            else $("#btnPrev").css('visibility','visible');
                            this.HandleBookmarkedStatus();
                            this.AppendQuestionNumber();
                            $("#btnNext").css("visibility", "visible");
                            $(".profile").show();
                            return;
                        }
                        }
                        FunctionCall(arg1, arg2);
                        if (arg1 == 4) {
                            this.isNextClicked = false;
                            if (Test.Section.ActiveSectionID != Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber - 1)) {
                                this.pageNo = 1;
                                $("#btnPrev").css('visibility', 'hidden');
                            }
                            else this.pageNo += 1;
                            if($('#StgInst')[0].style.display=="none") $("#UlExamAidList").css('display', 'block'); 
                        }
                        if (this.TestInfo.AssessmentTypeCode == "SELADAPTIVE") $("#btnPrev").css("display", "none");
                        if (arg1 == 3) {
                            this.isNextClicked = false;this.isPrevClicked = false;
                            if (Test.Section.ActiveSectionID != Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber + 1)) this.pageNo = Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions;
                            else {
                                this.pageNo -= 1;
                                if (this.pageNo == 1) $("#btnPrev").css('visibility', 'hidden');
                            }
                        }
                        this.endPageNo = Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo;
                        if ($(".quesNo") != null) $(".quesNo").html(this.pageNo + "&nbsp;of&nbsp;" + Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions);
                        switch (this.Preferences.StylesheetName.toLocaleLowerCase()) {
                            case "deepblue":
                                if (this.totalQuestionCount == Test.TestInfo.CurrentPageNumber)
                                    $("#btnNext").css('visibility', 'visible');
                                else
                                    $("#btnNext").css('visibility', 'visible');
                                this.HandleBookmarkedStatus();
                                //StandardTimeFunctions.ResetTime(StandardTimeFunctions.GetTimeInSeconds(ctTimer.value, 1));
                                //_timerID = setInterval("hlrTimeUpdate()", 1000);
                                break;
                        }
                        break;
                    case 1:
                        var target = arg2.target || arg2.srcElement || arg2.currentTarget;
                        FunctionCall(arg1, target);
                        break;
                }
                if(this.TestInfo.AssessmentTypeCode == "SSET" || this.TestInfo.AssessmentTypeCode == "HS"){
                    if (Test.TestInfo.CurrentPageNumber == Test.QuestionList.length && !Test.TestInfo.IsEvaluateResponse) this.isEnableSubmitButton = false;
                    else if (Test.QuestionList.length == Test.TestInfo.QuestionsPerPage && !Test.TestInfo.EvaluateResponse) this.isEnableSubmitButton = false;
                    else this.isEnableSubmitButton = false;
                }
                else{
                    if (Test.TestInfo.CurrentPageNumber == Test.QuestionList.length && !Test.TestInfo.IsEvaluateResponse) this.isEnableSubmitButton = true;
                    else if (Test.QuestionList.length == Test.TestInfo.QuestionsPerPage && !Test.TestInfo.EvaluateResponse) this.isEnableSubmitButton = true;
                    else this.isEnableSubmitButton = false;                    
                }       

            };
            this.CallConfirmSubmit = () => {
                if (this.CheckQuestionAttempted(questionDiv, qtype, Test.TestInfo.CurrentGUID)) {
                    Test.PopUpDivID = "dvCS";
                    Summary.ConfirmMessage("Answer Confirmation", "Click Yes to confirm your answer and continue to the next question.", this.callConfirm, TestFunctions.ClosePopUp);                   
                    return;
                }
                else {
                    Summary.ShowMessage(["Answer Required", "You cannot continue with this question unanswered."]);
                }

            };

            if (this.TestInfo.AssessmentTypeCode == "SELADAPTIVE" || this.TestInfo.IsAllowSkip == false) {
                questionDiv = $("#_" + Test.TestInfo.CurrentGUID)[0];
                qtype = $(questionDiv).attr("questiontype");
                if (Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionName.indexOf('Analytical Writing Assessment') != -1) {
                    if (!this.CheckQuestionAttempted(questionDiv, qtype, Test.TestInfo.CurrentGUID)) {
                        Test.TestInfo.TargetSectionID = Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber + 1);
                        Test.PopUpDivID = "dvCS";
                        Summary.ConfirmMessage("Answer Confirmation", "Do you want to continue with this question unanswered?", this.callConfirm, TestFunctions.ClosePopUp);
                        return;
                    }
                    else
                        this.CallConfirmSubmit();
                }
                else
                    this.CallConfirmSubmit();
            }
            else
                this.CallClickEvents();
        }
        catch (e) { }
    }
    CheckAdativeSection(sectionDetails: any, TargetSectionID: any): any {
        for (var i = 0; i < sectionDetails.Sections.length; i++) {
            if (Number(TargetSectionID.replace('AMS_', '')) == sectionDetails.Sections[i].SectionID && sectionDetails.Sections[i].SectionTypeCode != null && sectionDetails.Sections[i].SectionTypeCode == 'SAAIS01')
                return sectionDetails.Sections[i];
        }
        return false;
    }
    BookmarkClick(spnbookmark: any) {
        try {
            if (this.TestInfo.Status == 2) {
                if (this.bookMarkElement == null)
                    this.bookMarkElement = $(".RevSecFlag").find('span')[0];
                if (this.Test.QuestionInfo[this.QItems[this.mnpageNo - 1].ID].IsMarked) {
                    this.Test.QuestionInfo[this.QItems[this.mnpageNo - 1].ID].IsMarked = false;
                    $(this.bookMarkElement).removeClass("BookMarkImg");
                    $(".RevSecFlag span").css("background", "url(./Themes/DeepBlue/images/n_icons.png) no-repeat scroll left -67px transparent");
                }
                else {
                    this.Test.QuestionInfo[this.QItems[this.mnpageNo - 1].ID].IsMarked = true;
                    $(this.bookMarkElement).addClass("BookMarkImg");
                    $(".RevSecFlag span").css("background", "url(./Themes/DeepBlue/images/n_icons.png) no-repeat scroll left -103px transparent");
                }
                this.assessmentService.StoreBookMarkedStatus(this.appPath, this.GetQuestionUserResponseObject(this.Test.QuestionInfo[this.QItems[this.mnpageNo - 1].ID])).subscribe(result => {
                })
            } else {
                if (Test.QuestionInfo[Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1]].IsMarked) {
                    Test.QuestionInfo[Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1]].IsMarked = false;
                    $(spnbookmark).removeClass("BookMarkImg");
                    $(".RevSecFlag span").css("background", "url(./Themes/DeepBlue/images/n_icons.png) no-repeat scroll left -67px transparent");
                }
                else if (!Test.QuestionInfo[Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1]].IsMarked) {
                    Test.QuestionInfo[Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1]].IsMarked = true;
                    $(spnbookmark).addClass("BookMarkImg");
                    $(".RevSecFlag span").css("background", "url(./Themes/DeepBlue/images/n_icons.png) no-repeat scroll left -103px transparent");
                    $(".RevSecFlagSpanDisabled").css("background", "url(./Themes/DeepBlue/images/n_icons.png) no-repeat scroll left -103px transparent");
                }
            }
        }
        catch (ex) { }
    }
    HandleBookmarkedStatus() {
        if (typeof (Test.QuestionInfo[Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1]]) != 'undefined' && Test.QuestionInfo[Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1]].IsMarked) {
            Test.QuestionInfo[Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1]].IsMarked = true;
            $(".RevSecFlag span").addClass("BookMarkImg");
            $(".RevSecFlag span").css("background", "url(./Themes/DeepBlue/images/n_icons.png) no-repeat scroll left -103px transparent");
        }
        else if (typeof (Test.QuestionInfo[Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1]]) != 'undefined' && !Test.QuestionInfo[Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1]].IsMarked) {
            Test.QuestionInfo[Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1]].IsMarked = false;
            $(".RevSecFlag span").removeClass("BookMarkImg");
            $(".RevSecFlag span").css("background", "url(./Themes/DeepBlue/images/n_icons.png) no-repeat scroll left -67px transparent");
        }
    }
    AddQuestionInfo(id, answered, qtype, isMarked, IsDel, prevquestion, totalsecs, MetaDataName, isHintsClicked) {
        var objQuestion = new QuestionInfo(qtype, isMarked, false, '', totalsecs, MetaDataName, isHintsClicked);
        this.Test.QuestionInfo[id] = objQuestion;
    }
    CheckQuestionAttempted(questiondiv, qtype, msGUID): boolean {
        switch (qtype) {
            case "Situational Judgement Type":
                try {
                    var Parent = questiondiv;
                    var main = $(".SJTFCIMatrixTable", Parent);
                    var mainTable = $(".clsDvWidth", $(main));
                    var Trs = $("tr[trident='sjtfc']", $(mainTable));
                    var maInputs = $(":radio[question='true']:checked", Parent);
                    var select = $("select[id='" + msGUID + "']", Parent);
                    var ddlselect = false;
                    if (select != null && select.length > 0) {
                        if ((<any>select[0]).length > 1) {
                            for (var opt = 1; opt < (<any>select[0]).length; opt++) {
                                if ((<any>select[0]).children[opt].selected) { ddlselect = true; }
                            }
                        }
                    }
                    else if (select.length == 0) ddlselect = true;
                    if (ddlselect) {
                        switch ($(maInputs.parent()).attr("quesattr")) {
                            case 'single':
                                if ($('td', Trs[0]).length - 1 == maInputs.length) return true;
                                break;
                            case 'multiple':
                                if (Trs.length - 1 == maInputs.length) return true;
                                break;
                        }
                    }
                }
                catch (e) {
                }

                break;
            case "Multiple Choice Static":
                if (Test.QuestionInfo[Test.TestInfo.CurrentGUID].IsAnswered)
                    return true;
                break;
            case "Essay":
                if (TestFunctions.GetEssayEditorText(Test.QuestionInfo[Test.TestInfo.CurrentGUID].EditorID).length > 0)
                    return true;
                else
                    return false;
            case "Select a blank":
                var Parent = questiondiv;
                var choiceArr = $("select[question='true']", Parent);
                var attemptedStatusCount = 0;
                for (var mnChoices = 0; mnChoices < choiceArr.length; mnChoices++) {
                    if ((<any>choiceArr[mnChoices]).value != '')
                        attemptedStatusCount++;
                }
                if (choiceArr.length == attemptedStatusCount) return true;
                break;
        }
        return false;
    }

    ShowSectionInstructionOnEachCompleteSection() {
        try {
            clearTimeout(_timerID);
            $("#dvopacityscreen").hide();
            let targetSectionId = "", currentSectionId = "";
            if (this.TestInfo.AssessmentTypeCode == "SSET" || this.TestInfo.AssessmentTypeCode == "HS") {
                if (!this.isTimeOut && this.endSectionViewed == 2 && Test.TestInfo.CurrentPageNumber != Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo) Test.TestInfo.CurrentPageNumber = Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo;
            }
            if (this.isTimeOut) {
                targetSectionId = this.TargetSectionId;
                currentSectionId = this.ActiveSectionId;
                Test.TestInfo.CurrentGUID = null;
                if (this.TargetSectionId == "")
                    this.TargetSectionId = null;
            }
            else if (this.isPreviuousSectionTimeOut) {
                targetSectionId = this.TargetSectionId;
                currentSectionId = this.ActiveSectionId;
				currentSectionId=Test.Section.ActiveSectionID;
            }
            else {
                targetSectionId = Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber + 1);
                currentSectionId = Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber)
            }            
            if (currentSectionId == null ||currentSectionId == "" || typeof (currentSectionId) == 'undefined')
                currentSectionId = Test.Section.ActiveSectionID;
            if (typeof (currentSectionId) != 'undefined' && currentSectionId != null && currentSectionId != "" && typeof (Test.Section.SectionInfo[currentSectionId]) != "undefined")
                var CurerntsectionName = Test.Section.SectionInfo[currentSectionId].SectionName;
            if (typeof (targetSectionId) != "undefined" && targetSectionId != null && targetSectionId != "" && typeof (Test.Section.SectionInfo[targetSectionId]) != "undefined") {
				Test.Section.SectionInfo[targetSectionId].SectionName.toLocaleLowerCase().indexOf('integrated reasoning') != -1 ? this.isActiveIrSection = true : this.isActiveIrSection = false;
            }
			if(currentSectionId!="")
				this.SectionName = Test.Section.SectionInfo[currentSectionId].SectionName;
            var templateUrl = "";
            if (this.showNextSectionInstruciton) {
                if (this.TestInfo.AssessmentTypeCode == "SSET" || this.TestInfo.AssessmentTypeCode == "HS" ) {
                    if (Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions == 1 && this.IsSingleQuesSection) {
                        targetSectionId = Test.Section.GetSectionID(Test.TestInfo.CurrentPageNumber);
                        Test.TestInfo.CurrentPageNumber = Test.TestInfo.CurrentPageNumber - 1;
                        this.IsSingleQuesSection = false;
                    }
                } 
                if (targetSectionId == currentSectionId) {
                    $(".profile").hide(); $("#spnSecRev").hide();
                    $("#lblCurrentSecName").hide();
					$('#btnTemp').hide();
                    //$("#lblEndSection").show();
                    //$("#lblEndSection").html(CurerntsectionName);
					this.SectionName =Test.Section.SectionInfo[currentSectionId].SectionName;
					this.TotalQuestions =Test.Section.SectionInfo[targetSectionId].NumberOfQuestions;
					this.TotalTime =(Test.Section.SectionInfo[targetSectionId].TotalTime/60);										
                    if (this.endSectionViewed != 2)
					 {
						 if(this.TestInfo.AssessmentTypeCode == "SSET" || this.TestInfo.AssessmentTypeCode == "HS"){
                            this.isReviewMode = false;RvwTime = false;this.Review=false;
                            ShowEndsecInst();
                         }							
						 else{
							$("#EndSecInst").show();}
                         this.endSectionViewed = 2;
                     }
                     else {
                        if (this.TestInfo.AssessmentTypeCode == "SSET" || this.TestInfo.AssessmentTypeCode == "HS") {
                            ShowSectionInstructionDynamically();
                            Test.TestInfo.CurrentPageNumber = Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo;
                            this.isTimeOut = false;							 
                            if (Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions == 1 && (!this.IsSingleQuesSection)) Test.TestInfo.CurrentPageNumber = Test.TestInfo.CurrentPageNumber + 1;
                            if(this.CallClickEvents==undefined){this.FunctionCall(4, '$event', 0);}
                            else{this.CallClickEvents();}
                            try {
                                   //Since section is getting changed, this is called to update the current GUID and current section
                                   //Storing these values is helpful when the session gets timeout, just after section changes
                                   if (Test.Section.ActiveSectionID != '' && Test.TestInfo.CurrentGUID != '') {
                                       this.assessmentService.UpdateCurrentDetails(Test.Section.ActiveSectionID, Test.TestInfo.CurrentGUID).subscribe(result => {
                                           var reponseData: any;
                                           reponseData = result;
                                           if (reponseData == null || reponseData.length == 0 || reponseData.d == "") {
                                           }
                                       });
                                   }
                               }
                               catch (ex)
                               { }
                             if(Test.TestInfo.TimeRemaining<=0){
                                           StandardTimeFunctions.ResetTime(Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeAvail);
                                           Test.TestInfo.TimeRemaining = Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeAvail;}

                            this.isReviewMode = false; RvwTime = false; this.Review=true;this.endSectionViewed = 1;
                        }
                               
                               else {$("#EndSecInst").hide();$("#StartSecInst").show();}
                           this.showNextSectionInstruciton = false; this.isActiveIrSection = false;
                         }
                     
                   /* switch (CurerntsectionName.toLocaleLowerCase()) {
                        case "analytical writing assessment":
                            templateUrl = 'StartEndHtmlFiles/analytical-start-page.html';
                            this.showNextSectionInstruciton = false; this.isActiveIrSection = false;
                            this.endSectionViewed = 2;

                            break;
                        case "integrated reasoning":
                            if (this.endSectionViewed == 1) {
								templateUrl = 'StartEndHtmlFiles/integrated-reasoning-break-page.html';
                                this.endSectionViewed = 2;
                            }
                            else {
								templateUrl = 'StartEndHtmlFiles/integrated-reasoning-start-page.html';
                                this.showNextSectionInstruciton = false; this.isActiveIrSection = false;
                            }
                            break;
                        case "quantitative":
						case ("Quantitative Reasoning").toLowerCase():
                            if (this.endSectionViewed == 1) {
								templateUrl = 'StartEndHtmlFiles/quantitative-break-page.html';
                                this.endSectionViewed = 2; this.isActiveIrSection = false;
                            }
                            else {
								templateUrl = 'StartEndHtmlFiles/quantitative-start-page.html';
                                this.showNextSectionInstruciton = false; this.isActiveIrSection = false;
                            }
                            break;
                        case "verbal":
						case ("Verbal Reasoning").toLowerCase():
                            if (this.endSectionViewed == 1) {
								templateUrl = 'StartEndHtmlFiles/verbal-break-page.html';
                                this.endSectionViewed = 2; this.isActiveIrSection = false;
                            }
                            else {
								templateUrl = 'StartEndHtmlFiles/verbal-start-page.html';
                                this.showNextSectionInstruciton = false; this.isActiveIrSection = false;
                            }
                            break;
						default:ShowSectionInstructionDynamically();
							break;
                    }*/
					
                }
                else {
                    if (this.isEndExam) {
                        $("#dvTestContent").hide();
                        $("#dvHelp").hide();
                        $("#btns").hide();
                        $("#lblCurrentSecName").hide();
                        $(".RevSecFlag").hide();
                        $("#dvTimeLeft").hide();
                        $(".quesnum").hide();
						$('#btnTemp').hide();
                        this.isActiveIrSection = false;
                        switch (this.EndExamMessages) {
                            case 0:
                                //templateUrl = 'StartEndHtmlFiles/end-exam-page.html';
								$("#dvGoHome").hide();
								$("#EndSecInst").show();
                                this.EndExamMessages = 2;
                                break;
                            case 1:
                                templateUrl = 'StartEndHtmlFiles/report-or-cancel-page.html';
                                this.EndExamMessages = 2;
                                break;
                            case 2:
                                $("#dvSectioninstruction").hide();
                                TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 1);
                                var isAllQuestions = true;
                                this.assessmentService.GetTestResultSummary(isAllQuestions).subscribe(result => {
                                    this.resultSummary = result;									
                                    this.resultSummary = this.resultSummary.d;
									this.surveylink = this.resultSummary.ReturnURL;
                                    this.totalGMATscore = this.resultSummary.TotalScore;
                                    this.totalGMATPercentile = this.resultSummary.Percentile;
                                    this.GMATSectionScore = this.resultSummary.SectionScore;
                                    Test.TestInfo.IsSubmitClicked = true;
									$("#StartSecInst").hide();$("#EndSecInst").hide();
									$("#btnInstnNext").css("visibility","hidden");
                                    $("#gmatScoreScreen").show();
                                    $("#imgLoading").hide();
									$("#dvGoHome").show();
                                    templateUrl = '';
                                    this.EndExamMessages = 3;
                                    TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2);
                                });
                                break;
                            case 3:
                                $("#gmatScoreScreen").hide();
                                templateUrl = 'StartEndHtmlFiles/end-graduate-management-page.html';
                                this.EndExamMessages = 4;
                                break;
                            case 4:
                                Test.TestInfo.IsSubmitClicked = true;
                                location.href = "TestReview.aspx";
                                break;
                        }
                    }
                    else {
                        $(".profile").hide(); $("#spnSecRev").hide();
                        $("#lblCurrentSecName").hide();
						$('#btnTemp').hide();
                        //$("#lblEndSection").show();
                        if (this.isTimeOut || this.isPreviuousSectionTimeOut)
                            this.ActiveSectionId = this.TargetSectionId;
							 if (this.endSectionViewed != 2)
							 {
								if(this.TestInfo.AssessmentTypeCode == "SSET" || this.TestInfo.AssessmentTypeCode == "HS"){
                                    this.isReviewMode = false;RvwTime = false;this.Review=false;
                                    ShowEndsecInst();
                                }
								
								else{
								$("#EndSecInst").show();}
								this.endSectionViewed = 2;
							}
							else {
                                if (this.TestInfo.AssessmentTypeCode == "SSET" || this.TestInfo.AssessmentTypeCode == "HS") {
                                    ShowSectionInstructionDynamically();this.isTimeOut = false;
                                    Test.TestInfo.CurrentPageNumber = Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo;
                                    if (Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions == 1 && (!this.IsSingleQuesSection)) Test.TestInfo.CurrentPageNumber = Test.TestInfo.CurrentPageNumber + 1;
                                     if(this.CallClickEvents==undefined){this.FunctionCall(4, '$event', 0);}
                                     else{this.CallClickEvents();}
                                    try {
                                    if (Test.Section.ActiveSectionID != '' && Test.TestInfo.CurrentGUID != '') {
                                                this.assessmentService.UpdateCurrentDetails(Test.Section.ActiveSectionID, Test.TestInfo.CurrentGUID).subscribe(result => {
                                                    var reponseData: any;
                                                    reponseData = result;
                                                    if (reponseData == null || reponseData.length == 0 || reponseData.d == "") {
                                                    }
                                                });
                                            }
                                        }
                                        catch (ex)
                                        { }
                                     if(Test.TestInfo.TimeRemaining<=0){
                                        StandardTimeFunctions.ResetTime(Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeAvail);
                                        Test.TestInfo.TimeRemaining = Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeAvail;}
                                    this.Review=true;this.endSectionViewed = 1;this.isReviewMode = false;RvwTime = false;
                                }								
                                    else {$("#EndSecInst").hide();$("#StartSecInst").show();}
                                this.showNextSectionInstruciton = false; this.isActiveIrSection = false;
                            }                   
							/*switch (CurerntsectionName.toLocaleLowerCase())
								{
                            case "analytical writing assessment":
                                if (this.endSectionViewed == 2 || this.endSectionViewed == 1) {
									templateUrl = 'StartEndHtmlFiles/analytical-start-page.html';
                                    this.showNextSectionInstruciton = false;
                                    this.endSectionViewed = 0;
                                    this.isActiveIrSection = false;
                                }
                                else {
								templateUrl = 'StartEndHtmlFiles/analytical-end-page.html';
                                    this.endSectionViewed = 2;
                                    this.isActiveIrSection = false;
                                }
                                break;
                            case "integrated reasoning":
								 templateUrl = 'StartEndHtmlFiles/integrated-reasoning-end-page.html';
                                this.endSectionViewed = 2;
                                break;
                            case "quantitative":
							case ("Quantitative Reasoning").toLowerCase():
							    templateUrl = 'StartEndHtmlFiles/quantitative-end-page.html';
                                this.endSectionViewed = 2;
                                this.isActiveIrSection = false;
                                break;
                            case "verbal":
							case ("Verbal Reasoning").toLowerCase():
								templateUrl = 'StartEndHtmlFiles/verbal-end-page.html';
                                this.endSectionViewed = 2;
                                this.isActiveIrSection = false;
                                break;
							default:ShowSectionInstructionDynamically();
								break;
                        }*/	
													
						
                    }
                }
						$("#dvTestContent").hide();
                        //$("#dvSectioninstruction").show();
                        $("#btns").hide();
                        $(".btnforSectionsinstr").show();
                        $("#dvHelp").hide();
				if(this.TestInfo.AssessmentTypeCode == "SSET" || this.TestInfo.AssessmentTypeCode == "HS") {
					 if (templateUrl != '') {
                    this.assessmentService.GetFile(templateUrl).subscribe(result => {
                        this.sectionInstructionHtml = result.text();
                        TestFunctions.ShowOrHideProgressMessage(Test.Msg2, 2);
                        if (!this.showNextSectionInstruciton && this.randomsections) {
                            this.SetDisplay(true); this.randomsections = false;
                        }
                        $("#dvTestContent").hide();
                        $("#dvSectioninstruction").show();
                        $("#btns").hide();
                        $(".btnforSectionsinstr").show();
                        $("#dvHelp").hide();
                    });
                }
				}
            }
            else {
                this.showNextSectionInstruciton = true;
                Navigation.ShowSectionQuestions();
                $("#dvSectioninstruction").hide();
                $(".btnforSectionsinstr").hide();
                $("#lblCurrentSecName").show();
				 $("#startTestInst").css('display','none');
				  $(".quesnum").css('display','block');
                $("#lblEndSection").html("End Section");
                $("#lblEndSection").hide();
                $(".profile").show(); $("#spnSecRev").hide();
                $("#btns").show();
                $("#dvHelp").show();
                if (!$("#txtTimer").is(':visible'))
                    this.HideTimer();
                this.HandleBookmarkedStatus();
                _timerID = setInterval("hlrTimeUpdate()", 1000);
                StandardTimeFunctions.ResetTime(Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeAvail);
                Test.TestInfo.TimeRemaining = Test.Section.SectionInfo[Test.Section.ActiveSectionID].TimeAvail;
                this.timeoutTimer = setInterval(() => { this.CallBackFunctionForTimeUpdate(); }, 1000);
                try {
                    var CurerntsectionName = Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionName.toLocaleLowerCase();
                    if (CurerntsectionName.indexOf('integrated reasoning') != -1)
                        this.isActiveIrSection = true;
                    else
                        this.isActiveIrSection = false;
                }
                catch (e) { console.error(e) }

            }
        }
        catch (e) { console.error(e) }
    }	
    OpenHelpLink(): any {
        try {
            let metaDataValue; let itmIndex; let quesInfo;
            if (this.TestInfo.Status == 2) {
                itmIndex = this.mnpageNo - 1;
                if (this.QItems[itmIndex].MetaDataValue != null)
                    metaDataValue = this.QItems[itmIndex].MetaDataValue.toLocaleLowerCase();
                if (this.QItems[itmIndex].QType.toLocaleLowerCase() == "essay")
                    metaDataValue = "analytical";
                quesInfo = this.QItems[itmIndex]; 
            }
            else { 
                metaDataValue = Test.QuestionInfo[Test.TestInfo.CurrentGUID].MetaDataValue.toLocaleLowerCase();
                if (Test.QuestionInfo[Test.TestInfo.CurrentGUID].QType.toLocaleLowerCase() == "essay")
                    metaDataValue = "analytical"; 
                quesInfo = Test.QuestionInfo[Test.TestInfo.CurrentGUID];
            }
            let fileName = this.GetFileName(metaDataValue);
            let filepath = location.protocol + "//" + location.host + "/" + applicationPath + "/AdaptiveTest/static/exam/help/" + fileName;
            this.assessmentService.GetFile(filepath).subscribe(result => {
                $("#HelpDescp").html(result.text());
                this.HighlightTheHelpTab(metaDataValue, quesInfo);
                $("#dvHelpCose").css('display', 'block');
                $("#bgoverlaytest").addClass('bgoverlaytest');
            });
            $('#draggable').css('display', 'none');
        }
        catch (e) { }
    }
    CloseHelpdv(): any {
        try {
            $("#HelpDescp").html("");
            $("#dvHelpCose").css('display', 'none');
            $("#bgoverlaytest").removeClass('bgoverlaytest');
        }
        catch (e) { }
    }
    GetFileName(metaDataValue): any {
        var name;
        try {
            switch (metaDataValue) {
                case "analytical":
                    name = "analytical-help-content.html";
                    $("#awa_tab").addClass("active");
                    break;
                case "integrated reasoning":
                case "table analysis":
                case "two part analysis":
                case "graphical interpretation":
                case "multi source reasoning":
                    name = "ir-help.html";
                    break;
                case "quantitative":
                case "data sufficiency":
                case "problem solving":
                    name = "quant-help-content.html";
                    $("#awa_tab").addClass("active");
                    break;
                case "verbal":
                case "critical reasoning":
                case "reading comprehension":
                case "sentence correction":
                    name = "verbal-help-content.html";
                    $("#awa_tab").addClass("active");
                    break;
                default:
                    break;
            }
        }
        catch (e) { }
        return name;
    }
    HighlightTheHelpTab(metaDataValue, TestInfo): any {
        try {
            switch (metaDataValue) {
                case "data sufficiency":
                    $("#data_sufficiency_tab").addClass("active");
                    $("#data_sufficiency_ref").css('display', 'block');
                    break;
                case "problem solving":
                    $("#problem_solving_tab").addClass("active");
                    $("#problem_solving_ref").css('display', 'block');
                    break;
                case "critical reasoning":
                    $("#critical_reasoning_tab").addClass("active");
                    $("#critical_reasoning_ref").css('display', 'block');
                    break;
                case "reading comprehension":
                    $("#reading_comprehension_tab").addClass("active");
                    $("#reading_comprehension_ref").css('display', 'block')
                    break;
                case "sentence correction":
                    $("#sentence_correction_tab").addClass("active");
                    $("#sentence_correction_ref").css('display', 'block');
                    break;
                case "graphical interpretation":
                    $("#graphic_interpretation_tab").addClass("active");
                    $("#graphic_interpretation_ref").css('display', 'block');
                    break;
                case "table analysis":
                    $("#table_analysis_tab").addClass("active");
                    $("#table_analysis_ref").css('display', 'block');
                    break;
                case "two part analysis":
                    $("#two_part_analysis_tab").addClass("active");
                    $("#two_part_analysis_ref").css('display', 'block');
                    break;
                case "multi source reasoning":
                    $("#multisource_reasoning_tab").addClass("active");
                    $("#multisource_reasoning_ref").css('display', 'block');
                    break;
            }
        }
        catch (e) { }
    }
    HandlersOnPause(type) {
        try {
            switch (type) {
                case 1:
                    this.IsScreenPaused = true;
                    $('#dvPauseArea').show();
                    $('#dvTestContent').hide();
                    $('#spnPauseText').html("Res<u>u</u>me Exam");
                    this.TimeToRestartAfterPause = StandardTimeFunctions.GetTimeInSeconds(ctTimer.value, 1);
                    clearTimeout(_timerID);
                    break;
                case 2:
                    this.IsScreenPaused = false;
                    $('#dvPauseArea').hide();
                    $('#dvTestContent').show();
                    $('#spnPauseText').html("Pa<u>u</u>se Exam");
                    StandardTimeFunctions.ResetTime(this.TimeToRestartAfterPause);
                    _timerID = setInterval("hlrTimeUpdate()", 1000);
                    break;
            }
        }
        catch (ex) { }
    }
    PauseExam() {
        try {
            if (!$('#dvPauseArea').is(':visible'))
                this.HandlersOnPause(1);
            else
                this.HandlersOnPause(2);
        }
        catch (ex) { }
    }
	 ReturnToHomeDashboard() {
        try {
            var moData = null;
            if (typeof (TestFunctions) != "undefined") {
                TestFunctions.ClosePopUp(null, null, true);
                TestFunctions.ShowOrHideProgressMessage(Test.Msg2, 1);
                moData = TestFunctions.GetStoreStateValues(6);
            }
            this.assessmentService.ReturnParam(moData).subscribe(result => {
                var parameters: any = result;
				if(parameters.d==null && Test.TestInfo.TestPrefController != null && Test.TestInfo.TestPrefController.RequestType == "525")
					location.href = location.protocol + "//" + window.location.host + '/' + myGlobals.appPath + '/Category/List.aspx';
				else{  
                parameters = parameters.d;
                location.href = parameters.Extension2 + "?" + parameters.Extension1;}
            });
        }
        catch (ex)
        { }
    }
    SubmitExam() {
        try {
            Test.TestInfo.isSaveLaterClicked = true;
            this.SubmitExamYesClicked = true;
            if (Test.IsSubmitted || Test.TestInfo.IsSubmitClicked) return;
            var strIsStored = false;
            if (Test.TestInfo.IsTimeout && Test.TestInfo.EnforceTimeAt != 1)
                strIsStored = true;
            else {
                if (Test.ConfigPreferences.AuditTriallingEnabled) {
                    var Questiontype = Test.QuestionInfo[Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber - 1]].QType;
                    if (Question.Types.MultipleChoiceStatic != Questiontype.toUpperCase() && Question.Types.MultipleChoiceDynamic != Questiontype.toUpperCase() && Question.Types.LinkertScale != Questiontype.toUpperCase() && Question.Types.TrueOrFalse != Questiontype.toUpperCase() && Question.Types.DiscreteOptionMultipleChoice != Questiontype.toUpperCase() && Question.Types.EMQ != Questiontype.toUpperCase()) {
                        ActionSequence.RegisterNewAction(1, 8, Test.TestInfo.CurrentPageNumber, ctTimer.value, 1);
                        ActionSequence.UpdateLastAction(ActionStatusType.True, TestFunctions.StoreResponseAuditTrial(), '', '', '');
                    }
                }
                strIsStored = Navigation.StorePageResponse(Test.TestInfo.CurrentPageNumber);
            }
            if (!strIsStored) return;
            var strIsAllAns = false;
            TestFunctions.CloseAllWidgets();
            TestFunctions.GetUserResponseOptions();


            this.EndPracticeExam = () => {
                this.EndExamYesClicked = true;
                this.SubmitExamYesClicked = false;
                clearTimeout(_timerID);
                Test.PopUpDivID = "dvCS";
                TestFunctions.ClosePopUp(null, null, true);
                var submitMsg = `<p>You have chosen to save your practice exam for later. Would you like to be able to complete it later?</p> 
                                 <p>* Click Yes if you want to be able to return to your exam later and finish it. Your answers will be saved.</p>
                                 <p>* Click No if you do NOT want to return to it. The exam will be marked as Finished.<u>You will NOT receive any scores for this practice exam and your progress will be lost for this attempt.</u></p>`;
                var msMsg = submitMsg;
                Summary.ConfirmMessage("EndPracticeExam", msMsg, this.ResumeExam, this.ForceEndExam);
            };
            this.ResumeExam = () => {
                Navigation.HandleMediaContentOnSubmit();
                TestFunctions.ClosePopUp(null, null, true);
                TestFunctions.ShowOrHideProgressMessage(Test.Msg2, 1);
                var moData = TestFunctions.GetStoreStateValues(6);
                CloseTest(null);
                //this.assessmentService.ReturnParam(moData).subscribe(result => {
                //    var parameters: any = result;
                //    parameters = parameters.d;
                //    location.href = parameters.Extension2 + "?" + parameters.Extension1;
                //});
            };
            this.ForceEndExam = () => {
                Navigation.HandleMediaContentOnSubmit();
                TestFunctions.ClosePopUp(null, null, true);
                TestFunctions.ShowOrHideProgressMessage(Test.Msg2, 1);
                var moData = TestFunctions.GetStoreStateValues(6);
                this.assessmentService.ForceSubmitExam(moData).subscribe(result => {
                    if (result != null && result.d == "S001") {
                        CloseTest(null); 
                        //this.assessmentService.ReturnParam(moData).subscribe(result => {
                        //    var parameters: any = result;
                        //    parameters = parameters.d;
                        //    location.href = parameters.Extension2 + "?" + parameters.Extension1;
                        //});
                    }
                });
            };

            Test.PopUpDivID = "dvCS";
            var submitMsg = `<p style="text-align:center ">You are about to save your exam.
                                 If you click Yes below, your exam will be saved and you can return to it later.</br>
                                 If you click No below, you will return to your exam.</p>
                            <p>Are you sure you want to save your exam for later?</p>`;
            var msMsg = (Test.TestInfo.TotalQuestionsAttended != Test.QuestionInfo.children.length) ? submitMsg : Test.Msg35;
            if (Test.TestInfo.BookmarkedAlertOnSubmit)
                msMsg = TestFunctions.GetSubmitMessageIfBookmarked(msMsg);
            Summary.ConfirmMessage("End Exam", msMsg, this.EndPracticeExam, TestFunctions.ClosePopUp);
        }
        catch (e) { }
    }
    ShowNext() {
        if (this.bookMarkElement == null)
            this.bookMarkElement = $(".RevSecFlag").find('span')[0];
        if (this.mnpageNo == this.Test.QuestionList.length && this.TestInfo.AssessmentTypeCode == "SELADAPTIVE") {
            var URL = location.protocol + "//" + window.location.host + '/' + myGlobals.appPath + '/TestReview.aspx'
            window.location.href = URL;
            return;
        }
        $("#progress").show(); $("#dvopacityscreen").show()
        this.NavigateToNextQuestion = () => {
            if (this.Test.QuestionInfo[this.QItems[this.mnpageNo].ID].IsMarked) {
                $(this.bookMarkElement).addClass("BookMarkImg");
                $(this.bookMarkElement).css("background", "url(./Themes/DeepBlue/images/n_icons.png) no-repeat scroll left -103px transparent");
            }
            else {
                $(this.bookMarkElement).removeClass("BookMarkImg");
                $(this.bookMarkElement).css("background", "url(./Themes/DeepBlue/images/n_icons.png) no-repeat scroll left -67px transparent");
            }
            this.Test.QuestionList[this.mnpageNo - 1].style.display = "none";
            this.Test.QuestionList[this.mnpageNo].style.display = "block";
            this.endPageNo = this.solutionSectionInfo[this.QItems[this.mnpageNo].section.SectionID].QuestionCount;
            $("#lblEndSection").html(this.solutionSectionInfo[this.QItems[this.mnpageNo].section.SectionID].SectionName);
			if (this.solutionSectionInfo[this.QItems[this.mnpageNo].section.SectionID].SectionName == 'Analytical Writing Assessment') {
                $("#reviewAns").hide();
                $("#reviewCrt").hide();
            }
            else {
                $("#reviewAns").show();
                $("#reviewCrt").show();
				}
            $("#progress").hide(); $("#dvopacityscreen").hide();
            if (this.solutionSectionInfo[this.QItems[this.mnpageNo].section.SectionID].SectionName != this.solutionSectionInfo[this.QItems[this.mnpageNo - 1].section.SectionID].SectionName) this.pageNo = 1;
            else
                this.pageNo++;
            this.mnpageNo++;
            if (this.mnpageNo == this.Test.QuestionList.length)
                this.IsShowNextReviewButton = false;
            $(".quesNo").html(this.pageNo + "/" + this.endPageNo);
        }
        //if (this.Test.QuestionInfo[this.QItems[this.mnpageNo - 1].ID].IsMarked || !this.Test.QuestionInfo[this.QItems[this.mnpageNo - 1].ID].IsMarked) {
        //    this.assessmentService.StoreBookMarkedStatus(this.appPath, this.GetQuestionUserResponseObject(this.Test.QuestionInfo[this.QItems[this.mnpageNo - 1].ID])).subscribe(result => {
        //        this.NavigateToNextQuestion();
        //    })
        //}
        // else
        this.NavigateToNextQuestion();
    }
    GetQuestionUserResponseObject(moData) {
        var moQuestionList = [];
        this.UserResponseObject = {
            QuestionList: moQuestionList, AuditInfo: [],
            AuditList: [], TestInfo: this.TestInfo
        }
        //Object Notation
        var moQuestionList = [];
        moQuestionList.push(moData);
        var mnStPage, mnEdPage;
        this.UserResponseObject.QuestionList = (moQuestionList.length == 0) ? null : moQuestionList;
        this.UserResponseObject.SectionList = [];
        this.UserResponseObject.AuditList = [];
        this.UserResponseObject.TestInfo = {
        };
        this.UserResponseObject.TestInfo.PageNumber = this.TestInfo.CurrentPageNumber;
        this.UserResponseObject.TestInfo.QuestionGUID = this.QItems[this.mnpageNo - 1].ID;
        this.UserResponseObject.TestInfo.PauseRemainingTime = 0;
        this.UserResponseObject.TestInfo.ScheduleDetailUserID = this.TestInfo.ScheduleDetailUserID;
        return this.UserResponseObject;
    }
    SubmitSolution() {
        // this.assessmentService.ReturnParam(this.appPath, this.GetQuestionUserResponseObject(this.Test.QuestionInfo[this.QItems[this.mnpageNo - 1].ID])).subscribe(result => {
        //     //  TestFunctions.ShowOrHideProgressMessage(Test.Msg53, 2);   
        //     var reponse: any = result;
        //     var returnParam = JSON.parse(reponse.d);
        //     location.href = returnParam.Extension2 + "?" + returnParam.Extension1;
        // })
    }
    //ReviewScreen() {
    //    var URL = location.protocol + "//" + window.location.host + '/' + myGlobals.appPath + '/TestReview.aspx'
    //    window.location.href = URL;
    //}
    EndReviewQuestions(): any {
        try {
            //this.assessmentService.ReturnTOReport(0).subscribe(result => {
            //    this.OnSuccessTest(result);
            //});
            // this.CloseTest();
            $('#dvreviewEndPop').show();
        }
        catch (e) { }
    }
    OnSuccessTest(objResponse: any) {
        try {
            if (objResponse != null && objResponse.d != null && objResponse.d != '') {
                // var URL = myGlobals.ReportInterfaceURL +  "?" + objResponse.d;
                window.location.href = objResponse.d;
                return false;
            }
        }
        catch (ex) { }
    }
    HideQuestionNumber() {
        if (this.isQnsNumShown) {
            this.isQnsNumShown = false;
            $(".quesNo").show();
        }
        else {
            $(".quesNo").hide();
            this.isQnsNumShown = true;
        }
    }
    HideTimer() {
        if (this.isTimeShown) {
            this.isTimeShown = false;
            $("#txtTimer").show();
            $("#lblTimeLft").show();
			$("#txtpTimer").hide();
        }
        else {
            this.isTimeShown = true;
            $("#txtTimer").hide();
            $("#lblTimeLft").hide();
			$("#txtpTimer").hide();
        }
    }
    ShowMessage(msgs, delegatefun) {
        var DynamicWin = new DynamicWindow();
        DynamicWin.ButtonClickHandler1 = delegatefun;
        $("#dvAMtitle").html(msgs[0]);
        $("#dvmsg").html("<center>" + msgs[1] + "</center>");
        $("#dvmsg").append(DynamicWin.CreateMessageWithButton());
        $("#dvmsg").prepend("<div style=\"position: fixed;top: 0;left: 0;right: 0;width: 100%;height: 100%;background: #000; opacity: .5;z-index: -1;\"></div>");
        $("#dvAM").css("display", "block");
        Test.PopUpDivID = "dvAM";
    }
    CloseTest() {
        window.opener.location.reload();
        window.close(); return;
    }
    ConfirmationEndReview() {
        try {
            if (this.reviewPopUp.nativeElement.querySelector('#dvreviewEndPop') != null && this.reviewPopUp.nativeElement.querySelector('#dvreviewEndPop').length > 0) {
                var dPopUp = this.reviewPopUp.nativeElement;
                dPopUp.insertAdjacentHTML('beforeend', '<div class="cen_lgn_inn_bg" id="dvreviewPopBody" style="width: 450px;height: 90px;overflow: hidden;"><div style="float:none;text-align:center;padding-top:8px;padding-bottom:8px;font-weight:normal;" id="dvRWR1"><div style="position: fixed;top: 0;left: 0;right: 0;width: 100%;height: 100%;background: #000; opacity: .5;z-index: -1;"></div>You are about to exit the review of your practice exam, are you sure you want to exit? You will be able to return to it later.</div><div style="text-align: center; float: none; padding-left: 130px;"><div class="ctYes"><div class="btn" id="btn" style="display: block; float: left;"><a href="#"  (click)="CloseTest();"><span id="btnReviewEndYes" title="Yes">Yes</span> </a></div></div><div class="ctNo"> <div class="btn" id="btn" style="display: block; float: left;"><a href="#" (click)="ClosePopUp();"><span id="btnReviewEndNo"  title="No">No</span> </a> </div></div></div></div>');
            }
            else {
                var dPopUp = this.reviewPopUp.nativeElement;
                dPopUp.insertAdjacentHTML('beforeend', '<div class="cen_lgn_inn_bg" id="dvreviewPopBody" style="width: 450px;height: 90px;overflow: hidden;"><div style="float:none;text-align:center;padding-top:8px;padding-bottom:8px;font-weight:normal;" id="dvRWR1"><div style="position: fixed;top: 0;left: 0;right: 0;width: 100%;height: 100%;background: #000; opacity: .5;z-index: -1;"></div>You are about to exit the review of your practice exam, are you sure you want to exit? You will be able to return to it later.</div><div style="text-align: center; float: none; padding-left: 130px;"><div class="ctYes"><div class="btn" id="btn" style="display: block; float: left;"><a href="#" (click)="CloseTest();"><span id="btnReviewEndYes"  title="Yes">Yes</span> </a></div></div><div class="ctNo"> <div class="btn" id="btn" style="display: block; float: left;"><a href="#" (click)="ClosePopUp();"><span id="btnReviewEndNo"  title="No">No</span> </a> </div></div></div></div>');
            }
            $('#dvreviewEndPop').show();
        }
        catch (e) { }
    }
    ClosePopUp() {
        try {
            $('#dvreviewEndPop').hide();
        }
        catch (e) { }
    }
	EndReviewPkClick() {
        try {
				// if(this.TestPrefController.RequestType=="532"){
				// var message = JSON.stringify({ AssessmentID: this.TestInfo.AssessmentID, ProductID: 0});
				// CallAjaxJSONAsync(message, requestPath + "/Category/List.aspx/RedirectToReport", this.OnSuccessTest, this.OnFailure);
				// }
				// else{
					this.assessmentService.RedirectToNMATReport(applicationPath,this.TestInfo.AssessmentID,this.TestInfo.ProgramID).subscribe(result => {
						this.OnSuccessTest(result);
					});
			// }
        }
        catch (ex)
        { }
    }
	OnFailure(){}
    AssignResouceKeyValue() {
        try {
            this.FeedBackVal = FeedbackCultureVal;
            this.OptionAreaVal = OptionAreaCultVal;
        }
        catch (e) { }
    }
	ShowPrevious() {
        if (this.bookMarkElement == null)
            this.bookMarkElement = $(".RevSecFlag").find('span')[0];        
		 else if(this.mnpageNo==1){ $("btnReviewPrevious").hide(); return;}
		 //else if(this.pageNo!=this.startpageno){
                this.pageNo--;
                this.mnpageNo--;
     //}
        $("#progress").show(); $("#dvopacityscreen").show();
        this.NavigateToPreviousQuestion = () => {
           if (this.Test.QuestionInfo[this.QItems[this.mnpageNo-1].ID].IsMarked) {
                $(this.bookMarkElement).addClass("BookMarkImg");
                $(this.bookMarkElement).css("background", "url(./Themes/DeepBlue/images/n_icons.png) no-repeat scroll left -103px transparent");
            }
            else {
                $(this.bookMarkElement).removeClass("BookMarkImg");
                $(this.bookMarkElement).css("background", "url(./Themes/DeepBlue/images/n_icons.png) no-repeat scroll left -67px transparent");
            }
            this.Test.QuestionList[this.mnpageNo - 1].style.display = "block";
            this.Test.QuestionList[this.mnpageNo].style.display = "none";
				this.startpageno=this.pageNo+1;
				this.prevsecPno=this.solutionSectionInfo[this.QItems[this.mnpageNo-1].section.SectionID].QuestionCount;
            this.endPageNo = this.solutionSectionInfo[this.QItems[this.mnpageNo].section.SectionID].QuestionCount;           
            $("#progress").hide(); $("#dvopacityscreen").hide();
            $("#lblEndSection").html(this.solutionSectionInfo[this.QItems[this.mnpageNo].section.SectionID].SectionName);
            if (this.solutionSectionInfo[this.QItems[this.mnpageNo].section.SectionID].SectionName != this.solutionSectionInfo[this.QItems[this.mnpageNo - 1].section.SectionID].SectionName){
				 for(var i=0;i<this.SectionDetailsList.length;i++){
                     if (this.SectionInfo.Sections[i].SectionName == this.solutionSectionInfo[this.QItems[this.mnpageNo - 1].section.SectionID].SectionName) {
                         if (this.SectionInfo.Sections[i].Questions != null) {
                             for (var j = 0; j < this.SectionInfo.Sections[i].Questions.length; j++) {
                                 if (typeof (this.Test.QuestionInfo[this.SectionInfo.Sections[i].Questions[j].QuestionGUID]) == "undefined")
                                     this.QuesNotAttempted += 1;
                             }
                             if (this.QuesNotAttempted > 0) {
                                 this.pageNo = this.SectionInfo.Sections[i].Questions.length - this.QuesNotAttempted;
                                 this.QuesNotAttempted = 0;
                             }
                             else
                                 this.pageNo = this.SectionInfo.Sections[i].Questions.length;
                         }
                         else
                             this.pageNo = this.SectionInfo.Sections[i].QuestionCount; //if question is null
                     }
                 }
                $("#lblEndSection").html(this.solutionSectionInfo[this.QItems[this.mnpageNo - 1].section.SectionID].SectionName);		
               
			this.endPageNo=this.prevsecPno;  
			//this.pageNo=this.endPageNo;
            $(".quesNo").html(this.pageNo + "/" + this.endPageNo);}
            $(".quesNo").html(this.pageNo + "/" + this.endPageNo);
            if (this.solutionSectionInfo[this.QItems[this.mnpageNo-1].section.SectionID].SectionName == 'Analytical Writing Assessment') {
                $("#reviewAns").hide();
                $("#reviewCrt").hide();
            }
            else {
                $("#reviewAns").show();
                $("#reviewCrt").show();
            }
        }        
        this.NavigateToPreviousQuestion();
    }

    ReviewScreen() {
        try {
            Navigation.StorePageResponse(Test.TestInfo.CurrentPageNumber);
            $("#dvsciCalc").css('display', 'none');
            $("#divMainContent").removeAttr("background-color");            
            $("#dvTestContent").css('display', 'none');
            $('#StgInst').css('display', 'block');
            $("#UlExamAidList").css('display', 'none');
            $('#progress').css('display', 'none');
            $('#StageReview').css('display', 'block');
            $('#Reviewbtns').css('display', 'block');
            $('#btnNextIns').css('display', 'none');
            $('.tpl_qno_pad').css('display', 'none');
            $('.quesnum').hide();
            this.ReviewObject();
        }
        catch (e) { }
    }
    ReviewObject(): any {
        try {
			this.startcount=Test.Section.SectionInfo[Test.Section.ActiveSectionID].SPNo-1;
			this.endcount=Test.Section.SectionInfo[Test.Section.ActiveSectionID].EPNo-1;
            this.InCompleteQuesCount = 0;
            this.sectionReviewDetails = [];
            this.SecName = Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionName;
            for (var i = this.startcount; i <= this.endcount; i++) {
                var sec = { QuestionGuid: '', Isattended: false, IsBookMarked: false };
                var questionDiv = $("#_" + Test.QuestionInfo.children[i])[0];
				var qtype = $(questionDiv).attr("questiontype");
                sec.QuestionGuid = Test.QuestionInfo.children[i];
                //sec.Isattended = (Test.QuestionInfo[Test.QuestionInfo.children[i]].IsAnswered) ? true : false;
				sec.Isattended = (Test.QuestionInfo[Test.QuestionInfo.children[i]].IsAnswered)? true : false;
				if(qtype != "Situational Judgement Type" && qtype != "Select a blank"){
					if (!Test.QuestionInfo[Test.QuestionInfo.children[i]].IsAnswered) 						
						this.InCompleteQuesCount = this.InCompleteQuesCount + 1;							
                }
				else{
					if(!this.CheckQuestionAttempted(questionDiv, qtype, Test.QuestionInfo.children[i])) {
							this.InCompleteQuesCount = this.InCompleteQuesCount + 1;
							sec.Isattended = false;
						}
					}                       
                this.sectionReviewDetails.push(sec);
            }
        }
        catch (e) { }
    }
	 ReviewQuestions(val, qnum = -1) {
        try {
				$("#Reviewbtns").css('display', 'none');
                this.Review = true; var num = this.startcount; this.Rvwqueslist.length = 0;this.isReviewMode = true;
                RvwTime = this.Review;
				var IsAvailable: boolean = false;			
				if (val == 2){                                                             //ReviewUnattempted				
                for (var i = this.startcount; i <= this.endcount; i++){
					var questionDiv = $("#_" + Test.QuestionInfo.children[i])[0];
					var qtype = $(questionDiv).attr("questiontype");
					if(qtype != "Situational Judgement Type" && qtype != "Select a blank"){
						if (Test.QuestionInfo[Test.QuestionInfo.children[i]].IsAnswered == 0){
							this.Rvwqueslist[num] = Test.QuestionInfo[Test.QuestionInfo.children[i]].PrevQtn + 1;
							IsAvailable = true; num++;
						}
					}
					else{
							if(!this.CheckQuestionAttempted(questionDiv, qtype, Test.QuestionInfo.children[i])){
									this.Rvwqueslist[num] = Test.QuestionInfo[Test.QuestionInfo.children[i]].PrevQtn + 1;
									IsAvailable = true; num++;}
						}
					}					               
                if (!IsAvailable) {
                    Summary.ShowMessage(["Review", "No questions are unattended for review. Please make your selections and try again."]);
                    $("#Reviewbtns").css('display', 'block');
                    IsAvailable = false;
                    this.Review = false;
                    return false;
                }
            }
            else if (val == 1) {//ReviewBookmarked
                for (var i = this.startcount; i <= this.endcount; i++) {
                    if (Test.QuestionInfo[Test.QuestionInfo.children[i]].IsMarked) {
                        this.Rvwqueslist[num] = Test.QuestionInfo[Test.QuestionInfo.children[i]].PrevQtn + 1;
                        IsAvailable = true; num++;
                    }
                }
                if (!IsAvailable) {
                    Summary.ShowMessage(["Review", "No questions have been flagged for review. Please make your selections and try again."]);
                    $("#Reviewbtns").css('display', 'block');										
                    IsAvailable = false;
                    this.Review = false;
                    return false;
                }
            }
            else {//Review all
                 for (var i = this.startcount; i <= this.endcount; i++) {
                    this.Rvwqueslist[i] = Test.QuestionInfo[Test.QuestionInfo.children[i]].PrevQtn + 1;
                }
				  this.Review = false;                
            }
            this.RPQuestIndex = this.startcount;
            if (qnum != -1) this.RPQuestIndex = qnum;
			Test.TestInfo.PreviousPageNumber = Test.TestInfo.CurrentPageNumber;
            Test.TestInfo.CurrentPageNumber = this.Rvwqueslist[this.RPQuestIndex];			
			Test.TestInfo.CurrentGUID = Test.QuestionInfo.children[Test.TestInfo.CurrentPageNumber];
			TestFunctions.hlrAlternateFor_UpdateTime();
            Navigation.ShowPage(true);
            if (Test.TestInfo.CurrentPageNumber == this.Rvwqueslist[this.startcount]) $("#btnPrev").css('visibility','hidden');
            else $("#btnPrev").css('visibility','visible');
            this.HandleBookmarkedStatus();   
			this.ControlHandlersOnReviewClick();
            if (qnum != -1) {
                if (Test.TestInfo.CurrentPageNumber == this.Rvwqueslist[this.startcount]) $("#btnPrev").css('visibility','hidden');
				 else $("#btnPrev").css('visibility','visible');
                // if (Test.TestInfo.CurrentPageNumber == Test.QuestionInfo.children.length) $("#btnNext").css("display", "none");
            }
        }
        catch (e) { }
    }
	ControlHandlersOnReviewClick() {
        try {
            this.AppendQuestionNumber();
            $("#StgInst").hide();
            $("#dvopacityscreen").show();
            $(".pullleft").show();
            $(".profile").show();
            $(".hdnbtn").hide();
            $("#frmQuestion").show();
            $("#progress").hide();
            $("#dvopacityscreen").hide();
            $("#lowerStrip").show();
            $("#dvTestContent").css("display", "block");
            $("#btns").css("display", "block");
            $(".quesnum").css("display", "block");
            $("#spnSecRev").css("display", "block");
            $("#spnSecRev").css("top", "0px");
            $("#btnPrev").css("visibility", "hidden");
            $("#Reviewbtns").css("display", "none");                                       		   
			
            if (this.isActiveIrSection && $("#dvTestContent").is(":visible"))
                $("#UlExamAidList").css('display', 'block');
            else
                $("#UlExamAidList").css('display', 'none');
            //if (this.Rvwqueslist.length == 1) $("#btnNext").css("display", "none");
            $("#btnNext").css("visibility", "visible");
        }
        catch (ex) { }
    }
	 AppendQuestionNumber() {
        try {
            var SecTotQNum=Test.Section.SectionInfo[Test.Section.ActiveSectionID].NumberOfQuestions;
            var QNumber = this.GetQuestionNumber(Test.TestInfo.CurrentGUID);
            if ($(".quesNo").length > 0) {
                $(".quesNo").html(QNumber + "&nbsp;of&nbsp;" + SecTotQNum);
            }
        }
        catch (ex)
        { }
    }
	GetQuestionNumber(GUID) {
        try {
            for (var n = this.startcount; n <= this.endcount; n++) {
                if (this.QItems[n].ID == GUID) 
                return ((n-this.startcount) + 1);
            }
            return 0;
        }
        catch (ex)
        { }
    }
	reviewpopup() {
        $("#endreviewmodal").css('display', 'block');
    }
	Endreview(){
		$("#endreviewmodal").css('display', 'none');
	}
	EndSecReview(){
		if(Test.Section.SectionInfo[Test.Section.SectionInfo.children[Test.Section.SectionInfo[Test.Section.ActiveSectionID].SectionNumber]] == undefined){
			clearTimeout(_timerID);
			this.isTimeOut=true;
			TestFunctions._SubmitForm();}
		else
			this.ShowSectionInstructionOnEachCompleteSection();
	}
	showQueslist() {
        try {
            if ($("#queslist").css('display') == 'block' || $("#queslist").css('display') == 'inline-block' || $("#queslist").css('display') == 'inline')
                $("#queslist").css('display', 'none');
            else {
                $("#queslist").css('display', 'block');
                //$("#collapseOne").css('display', 'none');
            }
            var questImg = ($("#questimg").attr('src').trim() == './AdaptiveTest/Presentation/images/accord.png') ? './AdaptiveTest/Presentation/images/accordplus.png' : './AdaptiveTest/Presentation/images/accord.png';
            $("#questimg").attr('src', questImg);
        }
        catch (ex)
        { }
    }
    showInst() {
        try {
            if ($("#collapseOne").css('display') == 'block' || $("#collapseOne").css('display') == 'inline-block' || $("#collapseOne").css('display') == 'inline') {
                $("#collapseOne").css('display', 'none');
                // $("#queslist").css('display', 'block');                
            }
            else {
                $("#collapseOne").css('display', 'block');
                //$("#queslist").css('display', 'none');
            }
            var accordImg = ($("#accordimg").attr('src').trim() == './AdaptiveTest/Presentation/images/accord.png') ? './AdaptiveTest/Presentation/images/accordplus.png' : './AdaptiveTest/Presentation/images/accord.png';
            $("#accordimg").attr('src', accordImg);
        }
        catch (ex)
        { }
    }
	reviewEndScreen() {
        try {
            this.RPQuestIndex = 0;
            //this.UpdateResponse(Test.TestInfo.CurrentGUID, 1, $("#_" + Test.TestInfo.CurrentGUID)[0]);
            Navigation.StorePageResponse(Test.TestInfo.CurrentPageNumber);
            $("#dvTestContent").css("display", "none");
            $("#lowerStrip").css("display", "none");
            $("#spnSecRev").css("display", "none");
            $("#pagecount").css("display", "none");
            this.isReviewMode = false;
            this.ReviewScreen();
        }
        catch (ex) { }
    }

    receiveGraphDetails($event, qnsID) {
        $('#ResponseGraph_Canvas_' + qnsID).val($event);
    }
    @HostListener('window:keydown', ['$event'])
    keyEvent(event: KeyboardEvent) {
        try {
            // if (Test.ConfigPreferences.IsShortcutsEnabled) {
            if (this.TestInfo.AssessmentTypeCode == "SELADAPTIVE" || this.TestInfo.AssessmentTypeCode == "SSET" || this.TestInfo.AssessmentTypeCode == "HS") {
                if (this.TestInfo.Status != 2) {
                    if (event.altKey) {
                        switch (event.keyCode) {
                            //case KEY_CODE.ALT_E: if (!(Test.TestInfo.isSaveLaterClicked) && !($("#btnInstnNext").is(":visible")) && !$("#dvPauseArea").is(':visible') && $("#HelpDescp").html() == "") this.SubmitExam();
                            //    break;
                            case KEY_CODE.ALT_H: if (!($("#btnInstnNext").is(":visible")) && !$("#dvPauseArea").is(':visible') && !$("#dvCS").is(":visible")) this.OpenHelpLink();
                                break;
                            case KEY_CODE.ALT_N:
                                if (!$("#dvPauseArea").is(':visible') && $("#HelpDescp").html() == "") {
                                    if (!Test.TestInfo.isSaveLaterClicked && this.EndExamYesClicked && $("#dvCS").is(":visible") && !($("#btnInstnNext").is(":visible")))
                                        this.ForceEndExam();
                                    else if ($("#btnInstnNext").is(":visible") && !(Test.TestInfo.isSaveLaterClicked) && !(this.EndExamYesClicked))
                                        this.ShowSectionInstructionOnEachCompleteSection();
                                    else if ($("#dvCS").is(":visible") && !($("#btnInstnNext").is(":visible")) && !(this.EndExamYesClicked))
                                        TestFunctions.ClosePopUp();
                                    else if (!($("#dvCS").is(":visible")) && !($("#btnInstnNext").is(":visible")) && !(Test.TestInfo.isSaveLaterClicked) && !(this.EndExamYesClicked)) {
											if (Test.TestInfo.EvaluateRequestStatus == 1) {
                                            //Summary.ShowMessage(["Navigation", Message.QUESTIONEVALUATION]);
                                            return false;
											}
                                            if ($("#btnNext").is(":visible")) this.FunctionCall(4, '$event', 0);
                                    }
                                }
                                break;
                            case KEY_CODE.ALT_P:
                                if (this.TestInfo.AssessmentTypeCode != "SELADAPTIVE" && ($("#btnPrev").css("visibility") == "visible")) {
                                    if (this.pageNo != 1 && Test.TestInfo.CurrentPageNumber != Test.Section.SectionInfo[Test.Section.ActiveSectionID].SPNo ) this.FunctionCall(3, '$event', 0);
                                }
                                break;
                            case KEY_CODE.ALT_L: if (!($("#btnInstnNext").is(":visible")) && $("#HelpDescp").html() != "" && !$("#dvPauseArea").is(':visible')) this.CloseHelpdv();
                                break;
                            case KEY_CODE.ALT_Y:
                                if (Test.TestInfo.isSaveLaterClicked && !(this.EndExamYesClicked) && $("#dvCS").is(":visible") && !$("#dvPauseArea").is(':visible'))
                                    this.EndPracticeExam();
                                else if (!Test.TestInfo.isSaveLaterClicked && this.EndExamYesClicked && $("#dvCS").is(":visible") && !($("#btnInstnNext").is(":visible")) && !$("#dvPauseArea").is(':visible'))
                                    this.ResumeExam();
                                if ($("#dvCS").is(":visible") && !$("#dvPauseArea").is(':visible') && !(this.EndExamYesClicked) && !(Test.TestInfo.isSaveLaterClicked))
                                    this.callConfirm();
                                break;
                            case KEY_CODE.ALT_K:                                
								if ($("#dvAM").is(":visible") && !($("#btnInstnNext").is(":visible")) && !$("#dvPauseArea").is(':visible'))
                                    Summary.HideMessage();
                                break;
                            //case KEY_CODE.ALT_S: if (!($("#btnInstnNext").is(":visible")) && !$("#dvPauseArea").is(':visible') && $("#HelpDescp").html() == "" && !$("#dvCS").is(":visible")) this.PauseExam();
                            //    break;
                            case KEY_CODE.ALT_U: if (!($("#btnInstnNext").is(":visible")) && $("#dvPauseArea").is(':visible') && $("#HelpDescp").html() == "" && !$("#dvCS").is(":visible")) this.PauseExam();
                                break;
                        }
                    }
                }
                else if (this.TestInfo.Status == 2 && event.altKey && $("#btnReviewNext").is(":visible")) {
                    switch (event.keyCode) {
                        case KEY_CODE.ALT_D: if ($("#HelpDescp").html() == "") this.EndReviewQuestions();
                            break;
                        case KEY_CODE.ALT_H: if (!$('#dvreviewEndPop').is(':visible')) this.OpenHelpLink();
                            break;
                        case KEY_CODE.ALT_N: if ($("#dvreviewEndPop").is(':visible')) this.ClosePopUp(); else if ($("#HelpDescp").html() == "") this.ShowNext();
                            break;
                        case KEY_CODE.ALT_P: if ($("#dvreviewEndPop").is(':visible')) this.ClosePopUp(); else if ($("#HelpDescp").html() == "") this.ShowPrevious();
                            break;
						case KEY_CODE.ALT_O: if ($("#dvreviewEndPop").is(':visible')) this.ClosePopUp(); else if ($("#HelpDescp").html() == "") this.ShowAnswer();
                            break;
						case KEY_CODE.ALT_K: if ($("#dvreviewEndPop").is(':visible')) this.ClosePopUp(); else if ($("#HelpDescp").html() == "") this.CheckUserAnswer();
                            break;
                        case KEY_CODE.ALT_R: if (!$('#dvreviewEndPop').is(':visible') && $("#HelpDescp").html() == "") this.ReviewScreen();
                            break;
                        case KEY_CODE.ALT_L: if ($("#HelpDescp").html() != "" && !$('#dvreviewEndPop').is(':visible')) this.CloseHelpdv();
                            break;
                        case KEY_CODE.ALT_Y: if ($("#dvreviewEndPop").is(':visible')) this.CloseTest();
                            break;
                    }
                }
            }
            // }
        }
        catch (e) { }
    }
}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/app.taketest.ts